import Vue from "vue";

export function _captionFecha(fecha) {
  if (fecha) {
    return (
      fecha.substring(8, 10) +
      "/" +
      fecha.substring(5, 7) +
      "/" +
      fecha.substring(0, 4)
    );
  } else {
    return "";
  }
}

export function _captionBicisNumero(modelReserva) {
  let res = "";
  for (let index = 0; index < modelReserva.bicis.length; index++) {
    res =
      res +
      modelReserva.bicis[index].talla +
      modelReserva.bicis[index].numero.toString() +
      ", ";
  }
  return res.slice(0, -2);
}

function _filtrarSoloPaginaPrincipalPresupuesto(
  docDefinition,
  modelReserva,
  imprimirSoloPaginaPrincipal
) {
  if (!imprimirSoloPaginaPrincipal) {
    return docDefinition;
  }

  const indiceInicio = docDefinition.content.findIndex((item) => {
    const body =
      item &&
      item.table &&
      item.table.body &&
      item.table.body[0] &&
      item.table.body[0][0];

    const texto = body && body.text;
    return typeof texto == "string" && texto.includes(modelReserva.cod_presupuesto);
  });

  if (indiceInicio > 0) {
    docDefinition.content = docDefinition.content.slice(indiceInicio);
  }

  return docDefinition;
}

export async function reportePresupuesto(
  context,
  [
    modelReserva,
    presupuestoImagen1,
    presupuestoImagen2,
    presupuestoImagen3,
    presupuestoImagen4,
    presupuestoImagen5,
    presupuestoImagen6,
    presupuestoImagen7,
    presupuestoImagen8,
    presupuestoImagen12,
    presupuestoImagen13,
    presupuestoImagen14,
    tarifaSEUR,
    tarifaKm,
    importe_s,
    importe_m,
    importe_l,
    importe_xl,
    importe_ms,
    importe_mm,
    importe_ml,
    tarifaMenosDe7,
    tarifaMasDe7,
    imprimirSoloPaginaPrincipal
  ]
) {
  var docDefinition = {
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 10],

    content: [
      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#B3C6E7",
                fontSize: 20,
                text: "EBIKE COMPOSTELA",
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 10, 0, 0],
        fontSize: 16,
        text: "ALQUILER DE BICICLETAS ELÉCTRICAS y MUSCULARES",
        bold: true,
        alignment: "left",
        color: "#1E88E5",
      },
      {
        margin: [0, 20, 0, 0],
        fontSize: 14,
        text: "HAIBIKE ALLTRACK 7  --- CUBE REACTION HYBRID RACE 625",
        bold: true,
        alignment: "center",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 14,
        text: "                    Muscular: ORBEA OIZ H30",
        bold: true,
        alignment: "center",
      },
      {
        margin: [0, 20, 0, 10],
        fontSize: 12,
        text: "Podrás escoger la talla que mejor se adapte según tu estatura:",
        alignment: "left",
      },

      {
        columns: [
          {
            width: "auto",
            fit: [30, 80],
            image: presupuestoImagen1,
          },

          {
            margin: [0, 0, 0, 0],
            table: {
              widths: [40, "*"],
              body: [
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Talla S: desde 1,45 a 1,65 metros",
                ],
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Talla M: desde 1,65 a 1,80 metros",
                ],
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Talla L: desde 1,75 a 1,90 metros",
                ],
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Talla XL: desde 1,85 metros",
                ],

              ],
            },
            layout: "noBorders",
          },
        ],
      },

      {
        margin: [0, 20, 0, 0],
        fontSize: 12,
        text: "Características de nuestras bicis ELÉCTRICAS:",
        alignment: "left",
        bold: true,
        decoration: "underline",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·   Su motor proporciona asistencia para el pedaleo, ajustada con una configuración especifica de bicicleta de montaña para optimizar la bicicleta tanto en conducción suave, como brusca y todoterreno.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·   El sofisticado motor Bosch Drive CX de cuarta generación de todas nuestras bicicletas, utiliza una batería Bosch  de 625 wh, lo que significa que ninguna pendiente pronunciada o una larga resistencia podrá con ella.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·   El motor Yamaha PW-X3 más ligero, más pequeño y con una producción de par motor más alta que nunca, este propulsor de nueva generación ofrece una respuesta instantánea, con un rendimiento sobresaliente en uso offroad. Está diseñado para ofrecer la experiencia de pedaleo más pura y el rendimiento más emocionante.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 10, 0, 0],
        fontSize: 12,
        text: "Características de nuestras bicis MUSCULARES:",
        alignment: "left",
        bold: true,
        decoration: "underline",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·   Bicicleta de aluminio Orbea Oiz H30, con transmisión Shimano Deore de 12 velocidades y horquilla Fox 32 Float Rhythm de 120 mm de recorrido con control remoto.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 10, 0, 0],
        table: {
          widths: [60, "*"],
          body: [
            [
              {
                width: "auto",
                fit: [40, 100],
                image: presupuestoImagen2,
              },
              {
                text: "Recibirás la bicicleta en tu hotel o albergue el día anterior al inicio de ruta. Para ello necesitamos conocer tu fecha de salida con mínimo siete días de antelación.",
                alignment: "left",
                fontSize: 12,
                bold: true,
                color: "#375623",
                decoration: "underline",
              },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        margin: [0, 10, 0, 0],
        fontSize: 10,
        text: "Cuando termines tú ruta, no te preocupes por la bici, nosotros nos encargamos de recogerla donde más cómodo te sea (albergue, hotel).",
        alignment: "center",
        color: "#0070C0",
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [60, "*", 60, 180],
          body: [
            [
              {
                width: "auto",
                fit: [30, 80],
                image: presupuestoImagen3,
              },
              {
                text: [
                  { text: "Los puntos de devolución de bicicletas:", bold: true, fontSize: 10 },
                  "\n Santiago \n Fisterra (coste adicional 10 €)"],
                fontSize: 10,
                alignment: "left",
              },
              {
                width: "auto",
                fit: [30, 80],
                image: presupuestoImagen4,
              },
              {
                text: [{ text: "Tarifas Bicis Eléctricas:", bold: true, fontSize: 10 },
                "\n Alquiler de 3 a 7 días:    46,50 €/día \n " +
                "Alquiler de 8 a 15 días:  41,50 €/día \n "],
                fontSize: 10,
                alignment: "left",
              },
            ],

            [
              { text: "" },
              { text: "" },
              { text: "" },
              { text: "", alignment: "left" },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                width: "auto",
                fit: [200, 100],
                image: presupuestoImagen5,
                alignment: "center",
              },
              {
                width: "auto",
                fit: [200, 100],
                image: presupuestoImagen6,
                alignment: "center",
              },
            ],
            [
              {
                text: "Haibike Alltrack 7",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
              {
                text: "Cube Reaction Hybrid Race 625",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 10, 0, 0],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                width: "auto",
                fit: [200, 100],
                image: presupuestoImagen12,
                alignment: "center",
              },
              {
                margin: [60, 30, 0, 0],
                text: [{ text: "Tarifas Bici Muscular:", bold: true },
                "\n Alquiler de 3 a 7 días:    40 €/día \n " +
                "Alquiler de 8 a 15 días:  35 €/día \n "],
                fontSize: 10,
                alignment: "left",
              },
            ],
            [
              {
                text: "Orbea Oiz H 30",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
              {
                text: "",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },


/*
      {
        margin: [0, 10, 0, 0],
        width: "auto",
        fit: [40, 100],
        image: presupuestoImagen7,
        alignment: "right",
      },*/

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#B3C6E7",
                fontSize: 20,
                text:
                  "PRESUPUESTO " +
                  modelReserva.cod_presupuesto,
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: [60, "*"],
          body: [
            [
              { text: "Fecha:" },
              { text: _captionFecha(modelReserva.created_at) },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        margin: [0, 2, 0, 0],
        table: {
          widths: [120, "*"],
          body: [
            [
              { text: "Nombre y Apellidos:" },
              { text: modelReserva.cliente.nombre },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 2, 0, 0],
        table: {
          widths: [120, 120, 120, "*"],
          body: [
            [
              { text: "Fecha Inicio Alquiler:" },
              { text: _captionFecha(modelReserva.fecha_inicial), alignment: "left" },
              { text: "Lugar de Entrega:" },
              { text: modelReserva.ubicacion_inicial, alignment: "left" },
            ],
            [
              { text: "Fecha Fin Alquiler:" },
              { text: _captionFecha(modelReserva.fecha_final), alignment: "left" },
              { text: "Lugar de Recogida:" },
              { text: modelReserva.ubicacion_final, alignment: "left" },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        margin: [0, 10, 0, 0],
        fontSize: 12,
        text: "PRECIO ALQUILER EBIKE",
        bold: true,
        alignment: "left",
        color: "#FF0000",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          headerRows: 1,
          widths: [80, "*", "*", "*", "*"],
          body: [
            [
              { text: "Talla", bold: true, alignment: "center" },
              { text: "Unidades", bold: true, alignment: "center" },
              { text: "Nº de días", bold: true, alignment: "center" },
              { text: "Precio por día", bold: true, alignment: "right" },
              { text: "Importe", bold: true, alignment: "right" },
            ],
          ],
        },
        layout: "headerLineOnly",
      },

      {
        margin: [0, 5, 0, 0],
        fontSize: 12,
        text: "PRECIO de TRANSPORTE",
        bold: true,
        alignment: "left",
        color: "#FF0000",
      },

      {
        margin: [0, 2, 0, 0],
        table: {
          headerRows: 1,
          widths: ["*", "*", "*", "*"],
          body: [
            [
              { text: "Lugar de Entrega", bold: true, alignment: "center" },
              { text: "Km", bold: true, alignment: "center" },
              { text: "Precio Km", bold: true, alignment: "right" },
              { text: "Importe", bold: true, alignment: "right" },
            ],

            [
              { text: modelReserva.ubicacion_inicial, alignment: "center" },
              {
                text: modelReserva.transporte_km,
                alignment: "center",
              },
              { text: tarifaKm + " €", alignment: "right" },
              {
                text: modelReserva.transporte_importe + " €",
                alignment: "right",
              },
            ],
          ],
        },
        layout: "headerLineOnly",
      },

      (modelReserva.pedales_automaticos || modelReserva.seguro || modelReserva.bolsa_delantera || modelReserva.soporte_movil || modelReserva.credencial)?
      {
        margin: [0, 2, 0, 0],
        fontSize: 12,
        text: "PRECIO COMPLEMENTOS",
        bold: true,
        alignment: "left",
        color: "#FF0000",
      }:{
        margin: [0, 2, 0, 0],
        text: "",
        
      },

      (modelReserva.pedales_automaticos || modelReserva.seguro || modelReserva.bolsa_delantera || modelReserva.soporte_movil || modelReserva.credencial)?
      {
        margin: [0, 2, 0, 0],
        table: {
          headerRows: 1,
          widths: [150, "*", "*", "*"],
          body: [
            [
              { text: "Concepto", bold: true, alignment: "left" },
              { text: "Nº de días", bold: true, alignment: "center" },
              { text: "Precio por día", bold: true, alignment: "center" },
              { text: "Importe", bold: true, alignment: "right" },
            ],
          ],
        },
        layout: "headerLineOnly",
      }:{
        margin: [0, 2, 0, 0],
        text: "",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*", 100],
          body: [
            [
              { text: "TOTAL PRESUPUESTO", bold: true, alignment: "right" },
              {
                text: modelReserva.importe + " €",
                bold: true,
                alignment: "right",
              },
            ],
            modelReserva.descuento != null &&
              modelReserva.descuento != "" &&
              modelReserva.descuento != 0.0
              ? [
                { text: "DESCUENTO", bold: true, alignment: "right" },
                {
                  text: modelReserva.descuento + " €",
                  bold: true,
                  alignment: "right",
                },
              ]
              : ["", ""],

            [
              { text: "FIANZA", bold: true, alignment: "right" },
              {
                text: modelReserva.fianza + " €",
                bold: true,
                alignment: "right",
              },
            ],

            [
              { text: "TOTAL A PAGAR", bold: true, alignment: "right" },
              {
                fillColor: "#00B0F0",
                text: modelReserva.total + " €",
                bold: true,
                alignment: "right",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        text: "(Precios con IVA Incluido)", fontSize: 10
      },
      {
        text: "La fianza se devuelve al finalizar el alquiler.", fontSize: 10,

      },
      {
        margin: [0, 5, 0, 0],
        text: "Forma de pago:",
        fontSize: 10,
        italics: true,
        bold: true,
      },
      {
        margin: [0, 0, 0, 0],
        text: [
          "20% del presupuesto, ",
          // { text: "sin la fianza", color: "#FF0000" },
          "para formalizar la reserva.",
        ],
        fontSize: 10,
      },
      {
        margin: [0, 5, 0, 0],
        text: [
          "El importe pendiente 6 días hábiles antes del inicio del alquiler (Salvo entregas especiales).",
        ],
        fontSize: 10,
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "CAIXABANK    IBAN ES82 2100 4775 2502 0038 4614    BIC: CAIXESBBXXX",
                alignment: "left",
              },
            ]

          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "ABANCA          IBAN ES83 2080 0306 5130 4002 5574    BIC: CAGLESMMXXX",
                alignment: "left",
              },
            ]


          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "Bizum 699 331 965",
                alignment: "left",
              },
              {
                text: "",
              },
              {
                text: "",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],

        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                text: [
                  { fontSize: 10, text: "Incluye opcional sin coste:\n", bold: true },
                  { fontSize: 10, text: "Casco\n" +
                  "Kit de Pinchazos\n" +
                  "Botellín\n" +
                  "Alforjas\n" +
                  "Candado\n"}
                ],
                alignment: "left",
              },
              {
                text: [
                  { fontSize: 10, text: "Bajo petición con coste adicional:\n", bold: true },
                  { fontSize: 10, 
                    text: "Seguro Todo Riesgo    7€/día\n" +
                          "Pedales SPD                  3€/día\n" +
                          "Bolsa delantera             3€/día\n" +
                          "Soporte móvil                5€\n" +
                          "Credencial                      5€\n"}
                ],
                alignment: "left",
              },

            ],
          ],
        },
        layout: "noBorders",

      },




      /*{
        width: "auto",
        fit: [800, 100],
        image: presupuestoImagen13,
      },*/

      {
        margin: [40, 10, 0, 0],
        width: "auto",
        fit: [800, 100],
        image: presupuestoImagen14,
      },
    ],
  };

  var fila = [
    { text: "S", alignment: "center" },
    {
      text: modelReserva.cant_bicis_s > 0 ? modelReserva.cant_bicis_s : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_s > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_s > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_s > 0 ? importe_s + " €" : " - €",
      alignment: "right",
    },
  ];

  if (modelReserva.cant_bicis_s > 0) {
    docDefinition.content[22].table.body.push(fila);
  }


  fila = [
    { text: "M", alignment: "center" },
    {
      text: modelReserva.cant_bicis_m > 0 ? modelReserva.cant_bicis_m : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_m > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_m > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_m > 0 ? importe_m + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_m > 0) {
    docDefinition.content[22].table.body.push(fila);
  }
  fila = [
    { text: "L", alignment: "center" },
    {
      text: modelReserva.cant_bicis_l > 0 ? modelReserva.cant_bicis_l : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_l > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_l > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_l > 0 ? importe_l + " €" : " -€",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_l > 0) {
    docDefinition.content[22].table.body.push(fila);
  }
  fila = [
    { text: "XL", alignment: "center" },
    {
      text: modelReserva.cant_bicis_xl > 0 ? modelReserva.cant_bicis_xl : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_xl > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_xl > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_xl > 0 ? importe_xl + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_xl > 0) {
    docDefinition.content[22].table.body.push(fila);
  }

  fila = [
    { text: "MS", alignment: "center" },
    {
      text: modelReserva.cant_bicis_ms > 0 ? modelReserva.cant_bicis_ms : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_ms > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_ms > 0 ? modelReserva.precio_m + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_ms > 0 ? importe_ms + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_ms > 0) {
    docDefinition.content[22].table.body.push(fila);
  }

  fila = [
    { text: "MM", alignment: "center" },
    {
      text: modelReserva.cant_bicis_mm > 0 ? modelReserva.cant_bicis_mm : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_mm > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_mm > 0 ? modelReserva.precio_m + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_mm > 0 ? importe_mm + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_mm > 0) {
    docDefinition.content[22].table.body.push(fila);
  }

  fila = [
    { text: "ML", alignment: "center" },
    {
      text: modelReserva.cant_bicis_ml > 0 ? modelReserva.cant_bicis_ml : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_ml > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_ml > 0 ? modelReserva.precio_m + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_ml > 0 ? importe_ml + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_ml > 0) {
    docDefinition.content[22].table.body.push(fila);
  }

  if (modelReserva.pedales_automaticos) {
    docDefinition.content[26].table.body.push([
      { text: "Pedales SPD (Automáticos)", alignment: "left" },
      { text: modelReserva.cant_dias, alignment: "center" },
      { text: "3 €", alignment: "center" },
      { text: modelReserva.pedales_automaticos_importe + " €", alignment: "right" },
    ]);
  }

  if (modelReserva.seguro) {
    docDefinition.content[26].table.body.push([
      { text: "Seguro Todo Riesgo", alignment: "left" },
      { text: modelReserva.cant_dias, alignment: "center" },
      { text: "7 €", alignment: "center" },
      { text: modelReserva.seguro_importe + " €", alignment: "right" },
    ]);
  }

  if (modelReserva.bolsa_delantera) {
    docDefinition.content[26].table.body.push([
      { text: "Bolsa delantera", alignment: "left" },
      { text: modelReserva.cant_dias, alignment: "center" },
      { text: "3 €", alignment: "center" },
      { text: modelReserva.bolsa_delantera_importe + " €", alignment: "right" },
    ]);
  }

  if (modelReserva.soporte_movil) {
    docDefinition.content[26].table.body.push([
      { text: "Soporte móvil", alignment: "left" },
      { text: "", alignment: "center" },
      { text: "5 €", alignment: "center" },
      { text: modelReserva.soporte_movil_importe + " €", alignment: "right" },
    ]);
  }

  if (modelReserva.credencial) {
    docDefinition.content[26].table.body.push([
      { text: "Credencial", alignment: "left" },
      { text: "", alignment: "center" },
      { text: "5 €", alignment: "center" },
      { text: modelReserva.credencial_importe + " €", alignment: "right" },
    ]);
  }

  return _filtrarSoloPaginaPrincipalPresupuesto(
    docDefinition,
    modelReserva,
    imprimirSoloPaginaPrincipal
  );
}

export async function reportePresupuestoIngles(
  context,
  [
    modelReserva,
    presupuestoImagen1,
    presupuestoImagen2,
    presupuestoImagen3,
    presupuestoImagen4,
    presupuestoImagen5,
    presupuestoImagen6,
    presupuestoImagen7,
    presupuestoImagen8,
    presupuestoImagen12,
    presupuestoImagen13,
    presupuestoImagen14,
    tarifaSEUR,
    tarifaKm,
    importe_s,
    importe_m,
    importe_l,
    importe_xl,
    importe_ms,
    importe_mm,
    importe_ml,
    tarifaMenosDe7,
    tarifaMasDe7,
    imprimirSoloPaginaPrincipal
  ]
) {
  var docDefinition = {
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 10],

    content: [
      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#B3C6E7",
                fontSize: 20,
                text: "EBIKE COMPOSTELA",
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 10, 0, 0],
        fontSize: 16,
        text: "ELECTRIC AND MUSCLE BICYCLES RENTAL",
        bold: true,
        alignment: "left",
        color: "#1E88E5",
      },
      {
        margin: [0, 20, 0, 0],
        fontSize: 14,
        text: "HAIBIKE ALLTRACK 7  --- CUBE REACTION HYBRID RACE 625",
        bold: true,
        alignment: "center",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 14,
        text: "                    Muscle: ORBEA OIZ H30",
        bold: true,
        alignment: "center",
      },
      {
        margin: [0, 20, 0, 10],
        fontSize: 12,
        text: "You can choose the size that best suits your height:",
        alignment: "left",
      },

      {
        columns: [
          {
            width: "auto",
            fit: [30, 80],
            image: presupuestoImagen1,
          },

          {
            margin: [0, 0, 0, 0],
            table: {
              widths: [40, "*"],
              body: [
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Size S: from 1,45 to 1,65 meters",
                ],
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Size M: from 1,65 a 1,80 meters",
                ],
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Size L: from 1,75 a 1,90 meters",
                ],
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Size XL: from 1,85 meters",
                ],

              ],
            },
            layout: "noBorders",
          },
        ],
      },

      {
        margin: [0, 20, 0, 0],
        fontSize: 12,
        text: "Features of our ELECTRIC bikes:",
        alignment: "left",
        bold: true,
        decoration: "underline",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·   It´s motor provides pedaling assistance, adjusted with a specific mountain bike configuration to optimize the bicycle in both smooth, rough and off-road riding.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·    The Cube's sophisticated fourth-generation Bosch Drive CX motor uses a 625 wh Bosch battery, meaning no steep slope or long endurance will be enough.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·   The Yamaha PW-X3 engine is lighter, smaller and has higher torque production than ever before, this new generation engine offers instant response, with outstanding performance in off-road use. It is designed to offer the purest pedaling experience and the most exciting performance.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 10, 0, 0],
        fontSize: 12,
        text: "Features of our MUSCLE bikes:",
        bold: true,
        decoration: "underline",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·    Orbea Oiz H30 aluminum bicycle, with 12-speed Shimano Deore transmission and 120 mm travel Fox 32 Float Rhythm fork with remote control.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 10, 0, 0],
        table: {
          widths: [60, "*"],
          body: [
            [
              {
                width: "auto",
                fit: [40, 100],
                image: presupuestoImagen2,
              },
              {
                text: "You will receive the bicycle at your hotel or hostel the day before the start of the route. To do this we need to know your departure date at least seven days in advance.",
                alignment: "left",
                fontSize: 12,
                bold: true,
                color: "#375623",
                decoration: "underline",
              },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        margin: [0, 10, 0, 0],
        fontSize: 10,
        text: "When you finish your route, don't worry about the bike, we will take care of picking it up wherever it is most convenient for you (hotel, albergue).",
        alignment: "center",
        color: "#0070C0",
      },
      {
        margin: [0, 10, 0, 0],
        table: {
          widths: [60, "*", 60, 180],
          body: [
            [
              {
                width: "auto",
                fit: [30, 80],
                image: presupuestoImagen3,
              },
              {
                text: [
                  { text: "Bicycle return points:", bold: true, fontSize: 10 },
                  "\n Santiago \n Fisterra (coste adicional 10 €)"],
                fontSize: 10,
                alignment: "left",
              },
              {
                width: "auto",
                fit: [30, 80],
                image: presupuestoImagen4,
              },
              {
                text: [{ text: "Electric Bike Rates:", bold: true, fontSize: 10 },
                "\n Rental from 3 to 7 days:    46,50 €/day \n " +
                "Rental from 8 to 15 days:  41,50 €/day \n "],
                fontSize: 10,
                alignment: "left",
              },
            ],

            [
              { text: "" },
              { text: "" },
              { text: "" },
              { text: "", alignment: "left" },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                width: "auto",
                fit: [200, 100],
                image: presupuestoImagen5,
                alignment: "center",
              },
              {
                width: "auto",
                fit: [200, 100],
                image: presupuestoImagen6,
                alignment: "center",
              },
            ],
            [
              {
                text: "Haibike Alltrack 7",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
              {
                text: "Cube Reaction Hybrid Race 625",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                width: "auto",
                fit: [200, 100],
                image: presupuestoImagen12,
                alignment: "center",
              },
              {
                margin: [60, 30, 0, 0],
                text: [{ text: "Muscle Bike Rates:", bold: true },
                "\n Rental from 3 to 7 days:    40 €/day \n " +
                "Rental from 8 to 15 days:  35 €/day \n "],
                fontSize: 10,
                alignment: "left",
              },
            ],
            [
              {
                text: "Orbea Oiz H 30",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
              {
                text: "",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },


/*
      {
        margin: [0, 10, 0, 0],
        width: "auto",
        fit: [40, 100],
        image: presupuestoImagen7,
        alignment: "right",
      },*/

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#B3C6E7",
                fontSize: 20,
                text:
                  "BUDGET " +
                  modelReserva.cod_presupuesto,
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: [60, "*"],
          body: [
            [
              { text: "Date:" },
              { text: _captionFecha(modelReserva.created_at) },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        margin: [0, 2, 0, 0],
        table: {
          widths: [120, "*"],
          body: [
            [
              { text: "Name and surname:" },
              { text: modelReserva.cliente.nombre },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 2, 0, 0],
        table: {
          widths: [120, 120, 120, "*"],
          body: [
            [
              { text: "Start date:" },
              { text: _captionFecha(modelReserva.fecha_inicial), alignment: "left" },
              { text: "Delivery:" },
              { text: modelReserva.ubicacion_inicial, alignment: "left" },
            ],
            [
              { text: "End date:" },
              { text: _captionFecha(modelReserva.fecha_final), alignment: "left" },
              { text: "Pick Up:" },
              { text: modelReserva.ubicacion_final, alignment: "left" },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        margin: [0, 10, 0, 0],
        fontSize: 12,
        text: "EBIKE RENTAL PRICE",
        bold: true,
        alignment: "left",
        color: "#FF0000",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          headerRows: 1,
          widths: [80, "*", "*", "*", "*"],
          body: [
            [
              { text: "Size", bold: true, alignment: "center" },
              { text: "Units", bold: true, alignment: "center" },
              { text: "Nº days", bold: true, alignment: "center" },
              { text: "Price per day", bold: true, alignment: "right" },
              { text: "Amount", bold: true, alignment: "right" },
            ],
          ],
        },
        layout: "headerLineOnly",
      },

      {
        margin: [0, 10, 0, 0],
        fontSize: 12,
        text: "TRANSPORT PRICE",
        bold: true,
        alignment: "left",
        color: "#FF0000",
      },

      {
        margin: [0, 2, 0, 0],
        table: {
          headerRows: 1,
          widths: ["*", "*", "*", "*"],
          body: [
            [
              { text: "Delivery location", bold: true, alignment: "center" },
              { text: "Km", bold: true, alignment: "center" },
              { text: "Price", bold: true, alignment: "right" },
              { text: "Amount", bold: true, alignment: "right" },
            ],

            [
              { text: modelReserva.ubicacion_inicial, alignment: "center" },
              {
                text: modelReserva.transporte_km,
                alignment: "center",
              },
              { text: tarifaKm + " €", alignment: "right" },
              {
                text: modelReserva.transporte_importe + " €",
                alignment: "right",
              },
            ],
          ],
        },
        layout: "headerLineOnly",
      },

      (modelReserva.pedales_automaticos || modelReserva.seguro || modelReserva.bolsa_delantera || modelReserva.soporte_movil || modelReserva.credencial)?
      {
        margin: [0, 2, 0, 0],
        fontSize: 12,
        text: "COMPLEMENTS PRICE",
        bold: true,
        alignment: "left",
        color: "#FF0000",
      }:{
        margin: [0, 2, 0, 0],
        text: "",
      },

      (modelReserva.pedales_automaticos || modelReserva.seguro || modelReserva.bolsa_delantera || modelReserva.soporte_movil || modelReserva.credencial)?
      {
        margin: [0, 2, 0, 0],
        table: {
          headerRows: 1,
          widths: [150, "*", "*", "*"],
          body: [
            [
              
              { text: "Concept", bold: true, alignment: "left" },
              { text: "Nº of days", bold: true, alignment: "center" },
              { text: "Price per day", bold: true, alignment: "center" },
              { text: "Amount", bold: true, alignment: "right" },
            ],

          ],
        },
        layout: "headerLineOnly",
      }:{
        margin: [0, 2, 0, 0],
        text: "",
      },

      {
        margin: [0, 10, 0, 0],
        table: {
          widths: ["*", 100],
          body: [
            [
              { text: "TOTAL BUDGET", bold: true, alignment: "right" },
              {
                text: modelReserva.importe + " €",
                bold: true,
                alignment: "right",
              },
            ],
            modelReserva.descuento != null &&
              modelReserva.descuento != "" &&
              modelReserva.descuento != 0.0
              ? [
                { text: "DISCOUNT", bold: true, alignment: "right" },
                {
                  text: modelReserva.descuento + " €",
                  bold: true,
                  alignment: "right",
                },
              ]
              : ["", ""],

            [
              { text: "DEPOSIT", bold: true, alignment: "right" },
              {
                text: modelReserva.fianza + " €",
                bold: true,
                alignment: "right",
              },
            ],

            [
              { text: "TOTAL TO PAY", bold: true, alignment: "right" },
              {
                fillColor: "#00B0F0",
                text: modelReserva.total + " €",
                bold: true,
                alignment: "right",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        text: "(Prices with VAT included)", fontSize: 10
      },
      {
        text: "The deposit is returned at the end of the rental", fontSize: 10,

      },
      {
        margin: [0, 5, 0, 0],
        text: "Method of payment:",
        fontSize: 10,
        italics: true,
        bold: true,
      },
      {
        margin: [0, 0, 0, 0],
        text: [
          "20% of the budget, ",
          // { text: "sin la fianza", color: "#FF0000" },
          "to formalize the reservation.",
        ],
        fontSize: 10,
      },
      {
        margin: [0, 5, 0, 0],
        text: [
          "The amount pending 6 business days before the start of rental (except special deliveries)",
        ],
        fontSize: 10,
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "CAIXABANK    IBAN ES82 2100 4775 2502 0038 4614    BIC: CAIXESBBXXX",
                alignment: "left",
              },
            ]

          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "ABANCA          IBAN ES83 2080 0306 5130 4002 5574    BIC: CAGLESMMXXX",
                alignment: "left",
              },
            ]


          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "Credit card",
                alignment: "left",
              },
              {
                text: "",
              },
              {
                text: "",
              },
            ],
          ],
        },
        layout: "noBorders",
      },


      {
        margin: [0, 5, 0, 0],

        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                text: [
                  { fontSize: 10, text: "Optional includes at no cost:\n", bold: true },
                  { fontSize: 10, text: "Helmet\n" +
                  "Puncture Kit\n" +
                  "Bottle\n" +
                  "Saddlebags\n" +
                  "Padlock\n"}
                ],
                alignment: "left",
              },
              {
                text: [
                  { fontSize: 10, text: "On request with additional cost:\n", bold: true },
                  { fontSize: 10, 
                    text: "All Risk Insurance       7€/day\n" +
                          "Pedals SPD                  3€/day\n" +
                          "Front bag                      3€/day\n" +
                          "Mobile support            5€\n" +
                          "Credential                    5€\n"}
                ],
                alignment: "left",
              },

            ],
          ],
        },
        layout: "noBorders",

      },




  /*    {
        width: "auto",
        fit: [800, 50],
        image: presupuestoImagen13,
      },*/

      {
        margin: [40, 10, 0, 0],
        width: "auto",
        fit: [800, 100],
        image: presupuestoImagen14,
      },
    ],
  };

  var fila = [
    { text: "S", alignment: "center" },
    {
      text: modelReserva.cant_bicis_s > 0 ? modelReserva.cant_bicis_s : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_s > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_s > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_s > 0 ? importe_s + " €" : " - €",
      alignment: "right",
    },
  ];

  if (modelReserva.cant_bicis_s > 0) {
    docDefinition.content[22].table.body.push(fila);
  }


  fila = [
    { text: "M", alignment: "center" },
    {
      text: modelReserva.cant_bicis_m > 0 ? modelReserva.cant_bicis_m : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_m > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_m > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_m > 0 ? importe_m + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_m > 0) {
    docDefinition.content[22].table.body.push(fila);
  }
  fila = [
    { text: "L", alignment: "center" },
    {
      text: modelReserva.cant_bicis_l > 0 ? modelReserva.cant_bicis_l : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_l > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_l > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_l > 0 ? importe_l + " €" : " -€",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_l > 0) {
    docDefinition.content[22].table.body.push(fila);
  }
  fila = [
    { text: "XL", alignment: "center" },
    {
      text: modelReserva.cant_bicis_xl > 0 ? modelReserva.cant_bicis_xl : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_xl > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_xl > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_xl > 0 ? importe_xl + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_xl > 0) {
    docDefinition.content[22].table.body.push(fila);
  }

  fila = [
    { text: "MS", alignment: "center" },
    {
      text: modelReserva.cant_bicis_ms > 0 ? modelReserva.cant_bicis_ms : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_ms > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_ms > 0 ? modelReserva.precio_m + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_ms > 0 ? importe_ms + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_ms > 0) {
    docDefinition.content[22].table.body.push(fila);
  }

  fila = [
    { text: "MM", alignment: "center" },
    {
      text: modelReserva.cant_bicis_mm > 0 ? modelReserva.cant_bicis_mm : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_mm > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_mm > 0 ? modelReserva.precio_m + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_mm > 0 ? importe_mm + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_mm > 0) {
    docDefinition.content[22].table.body.push(fila);
  }

  fila = [
    { text: "ML", alignment: "center" },
    {
      text: modelReserva.cant_bicis_ml > 0 ? modelReserva.cant_bicis_ml : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_ml > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_ml > 0 ? modelReserva.precio_m + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_ml > 0 ? importe_ml + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_ml > 0) {
    docDefinition.content[22].table.body.push(fila);
  }

  if (modelReserva.pedales_automaticos) {
    docDefinition.content[26].table.body.push([
      { text: "Pedals SPD (Automatic)", alignment: "left" },
      { text: modelReserva.cant_dias, alignment: "center" },
      { text: "3 €", alignment: "center" },
      { text: modelReserva.pedales_automaticos_importe + " €", alignment: "right" },
    ]);
  }

  if (modelReserva.seguro) {
    docDefinition.content[26].table.body.push([
      { text: "All Risk Insurance", alignment: "left" },
      { text: modelReserva.cant_dias, alignment: "center" },
      { text: "7 €", alignment: "center" },
      { text: modelReserva.seguro_importe + " €", alignment: "right" },
    ]);
  }

  if (modelReserva.bolsa_delantera) {
    docDefinition.content[26].table.body.push([
      { text: "Front bag", alignment: "left" },
      { text: modelReserva.cant_dias, alignment: "center" },
      { text: "3 €", alignment: "center" },
      { text: modelReserva.bolsa_delantera_importe + " €", alignment: "right" },
    ]);
  }

  if (modelReserva.soporte_movil) {
    docDefinition.content[26].table.body.push([
      { text: "Mobile support", alignment: "left" },
      { text: "", alignment: "center" },
      { text: "5 €", alignment: "center" },
      { text: modelReserva.soporte_movil_importe + " €", alignment: "right" },
    ]);
  }

  if (modelReserva.credencial) {
    docDefinition.content[26].table.body.push([
      { text: "Credential", alignment: "left" },
      { text: "", alignment: "center" },
      { text: "5 €", alignment: "center" },
      { text: modelReserva.credencial_importe + " €", alignment: "right" },
    ]);
  }


  return _filtrarSoloPaginaPrincipalPresupuesto(
    docDefinition,
    modelReserva,
    imprimirSoloPaginaPrincipal
  );
}

export async function reportePresupuestoPortugues(
  context,
  [
    modelReserva,
    presupuestoImagen1,
    presupuestoImagen2,
    presupuestoImagen3,
    presupuestoImagen4,
    presupuestoImagen5,
    presupuestoImagen6,
    presupuestoImagen7,
    presupuestoImagen8,
    presupuestoImagen12,
    presupuestoImagen13,
    presupuestoImagen14,
    tarifaSEUR,
    tarifaKm,
    importe_s,
    importe_m,
    importe_l,
    importe_xl,
    importe_ms,
    importe_mm,
    importe_ml,
    tarifaMenosDe7,
    tarifaMasDe7,
    imprimirSoloPaginaPrincipal
  ]
) {
  var docDefinition = {
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 10],

    content: [
      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#B3C6E7",
                fontSize: 20,
                text: "EBIKE COMPOSTELA",
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 10, 0, 0],
        fontSize: 16,
        text: "ALUGUER DE BICICLETA ELÉTRICA E MUSCULAR",
        bold: true,
        alignment: "left",
        color: "#1E88E5",
      },
      {
        margin: [0, 20, 0, 0],
        fontSize: 14,
        text: "HAIBIKE ALLTRACK 7  --- CUBE REACTION HYBRID RACE 625",
        bold: true,
        alignment: "center",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 14,
        text: "                    Muscle: ORBEA OIZ H30",
        bold: true,
        alignment: "center",
      },
      {
        margin: [0, 20, 0, 10],
        fontSize: 12,
        text: "Você pode escolher o tamanho que melhor se adapta à sua altura:",
        alignment: "left",
      },

      {
        columns: [
          {
            width: "auto",
            fit: [30, 80],
            image: presupuestoImagen1,
          },

          {
            margin: [0, 0, 0, 0],
            table: {
              widths: [40, "*"],
              body: [
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Tamanho S: desde 1,45 a 1,65 metros",
                ],
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Tamanho M: desde 1,65 a 1,80 metros",
                ],
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Tamanho L: desde 1,75 a 1,90 metros",
                ],
                [
                  { text: "---", alignment: "right", fontSize: 12, },
                  "Tamanho XL: desde 1,85 metros",
                ],

              ],
            },
            layout: "noBorders",
          },
        ],
      },

      {
        margin: [0, 20, 0, 0],
        fontSize: 12,
        text: "Características de nossas bicicletas ELÉTRICAS:",
        alignment: "left",
        bold: true,
        decoration: "underline",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·   O seu motor proporciona assistência à pedalada, ajustado com uma configuração específica de mountain bike para otimizar a bicicleta tanto em passeios suaves, acidentados e off-road.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·   O sofisticado motor Bosch Drive CX de quarta geração do Cube utiliza uma bateria Bosch de 625 wh, o que significa que nenhuma inclinação acentuada ou longa resistência serão suficientes.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·   O motor Yamaha PW-X3 é mais leve, menor e tem maior produção de torque do que nunca, este motor de nova geração oferece resposta instantânea, com excelente desempenho em uso off-road. Ele foi projetado para oferecer a mais pura experiência de pedalada e o desempenho mais emocionante.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 10, 0, 0],
        fontSize: 12,
        text: "Características de nossas bicicletas MUSCLE:",
        alignment: "left",
        bold: true,
        decoration: "underline",
        color: "#AAAAAA",
      },
      {
        margin: [0, 0, 0, 0],
        fontSize: 10,
        text: "·   Bicicleta Orbea Oiz H30 em alumínio, com transmissão Shimano Deore de 12 velocidades e garfo Fox 32 Float Rhythm de 120 mm de curso com comando à distância.",
        alignment: "left",
        color: "#AAAAAA",
      },
      {
        margin: [0, 10, 0, 0],
        table: {
          widths: [60, "*"],
          body: [
            [
              {
                width: "auto",
                fit: [40, 100],
                image: presupuestoImagen2,
              },
              {
                text: "Você receberá a bicicleta em seu hotel ou pousada um dia antes do início do percurso. Para isso precisamos saber a data da sua partida com pelo menos sete dias de antecedência.",
                alignment: "left",
                fontSize: 12,
                bold: true,
                color: "#375623",
                decoration: "underline",
              },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        margin: [0, 10, 0, 0],
        fontSize: 10,
        text: "Ao terminar o seu percurso, não se preocupe com a bicicleta, nós nos encarregaremos de retirá-la onde for mais conveniente para você (hospedagem, hotel).",
        alignment: "center",
        color: "#0070C0",
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [60, "*", 60, 180],
          body: [
            [
              {
                width: "auto",
                fit: [30, 80],
                image: presupuestoImagen3,
              },
              {
                text: [
                  { text: "Pontos de devolução de bicicletas:", bold: true, fontSize: 10 },
                  "\n Santiago \n Fisterra (custo adicional de 10 €)"],
                fontSize: 10,
                alignment: "left",
              },
              {
                width: "auto",
                fit: [30, 80],
                image: presupuestoImagen4,
              },
              {
                text: [{ text: "Tarifas para bicicletas elétricas:", bold: true, fontSize: 10 },
                "\n Aluguel de 3 a 7 días:    46,50 €/día \n " +
                "Aluguel de 8 a 15 días:  41,50 €/día \n "],
                fontSize: 10,
                alignment: "left",
              },
            ],

            [
              { text: "" },
              { text: "" },
              { text: "" },
              { text: "", alignment: "left" },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                width: "auto",
                fit: [200, 100],
                image: presupuestoImagen5,
                alignment: "center",
              },
              {
                width: "auto",
                fit: [200, 100],
                image: presupuestoImagen6,
                alignment: "center",
              },
            ],
            [
              {
                text: "Haibike Alltrack 7",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
              {
                text: "Cube Reaction Hybrid Race 625",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 10, 0, 0],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                width: "auto",
                fit: [200, 100],
                image: presupuestoImagen12,
                alignment: "center",
              },
              {
                margin: [60, 30, 0, 0],
                text: [{ text: "Tarifas Bici Muscular:", bold: true },
                "\n Aluguel de 3 a 7 días:    40 €/día \n " +
                "Aluguel de 8 a 15 días:  35 €/día \n "],
                fontSize: 10,
                alignment: "left",
              },
            ],
            [
              {
                text: "Orbea Oiz H 30",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
              {
                text: "",
                fontSize: 12,
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },


/*
      {
        margin: [0, 10, 0, 0],
        width: "auto",
        fit: [40, 100],
        image: presupuestoImagen7,
        alignment: "right",
      },*/

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#B3C6E7",
                fontSize: 20,
                text:
                  "ORÇAMENTO " +
                  modelReserva.cod_presupuesto,
                bold: true,
                alignment: "center",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: [60, "*"],
          body: [
            [
              { text: "Data:" },
              { text: _captionFecha(modelReserva.created_at) },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        margin: [0, 2, 0, 0],
        table: {
          widths: [120, "*"],
          body: [
            [
              { text: "Nome e sobrenome:" },
              { text: modelReserva.cliente.nombre },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 2, 0, 0],
        table: {
          widths: [120, 120, 120, "*"],
          body: [
            [
              { text: "F.Inicio do Aluguel:" },
              { text: _captionFecha(modelReserva.fecha_inicial), alignment: "left" },
              { text: "Local de entrega:" },
              { text: modelReserva.ubicacion_inicial, alignment: "left" },
            ],
            [
              { text: "F. Fim do Aluguel:" },
              { text: _captionFecha(modelReserva.fecha_final), alignment: "left" },
              { text: "Local de retorno:" },
              { text: modelReserva.ubicacion_final, alignment: "left" },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        margin: [0, 10, 0, 0],
        fontSize: 12,
        text: "PREÇO DE ALUGUEL DE EBIKE",
        bold: true,
        alignment: "left",
        color: "#FF0000",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          headerRows: 1,
          widths: [80, "*", "*", "*", "*"],
          body: [
            [
              { text: "Tamanho", bold: true, alignment: "center" },
              { text: "Unidades", bold: true, alignment: "center" },
              { text: "Nº de días", bold: true, alignment: "center" },
              { text: "Preço por dia", bold: true, alignment: "right" },
              { text: "Quantia", bold: true, alignment: "right" },
            ],
          ],
        },
        layout: "headerLineOnly",
      },

      {
        margin: [0, 5, 0, 0],
        fontSize: 12,
        text: "PREÇO de TRANSPORTE",
        bold: true,
        alignment: "left",
        color: "#FF0000",
      },

      {
        margin: [0, 2, 0, 0],
        table: {
          headerRows: 1,
          widths: ["*", "*", "*", "*"],
          body: [
            [
              { text: "Local de entrega", bold: true, alignment: "center" },
              { text: "Km", bold: true, alignment: "center" },
              { text: "Preço Km", bold: true, alignment: "right" },
              { text: "Quantia", bold: true, alignment: "right" },
            ],

            [
              { text: modelReserva.ubicacion_inicial, alignment: "center" },
              {
                text: modelReserva.transporte_km,
                alignment: "center",
              },
              { text: tarifaKm + " €", alignment: "right" },
              {
                text: modelReserva.transporte_importe + " €",
                alignment: "right",
              },
            ],
          ],
        },
        layout: "headerLineOnly",
      },

      (modelReserva.pedales_automaticos || modelReserva.seguro || modelReserva.bolsa_delantera || modelReserva.soporte_movil || modelReserva.credencial)?
      {
        margin: [0, 2, 0, 0],
        fontSize: 12,
        text: "PREÇO DE COMPLEMENTOS",
        bold: true,
        alignment: "left",
        color: "#FF0000",
      }:{
        margin: [0, 2, 0, 0],
        text: "",
        
      },

      (modelReserva.pedales_automaticos || modelReserva.seguro || modelReserva.bolsa_delantera || modelReserva.soporte_movil || modelReserva.credencial)?
      {
        margin: [0, 2, 0, 0],
        table: {
          headerRows: 1,
          widths: [150, "*", "*", "*"],
          body: [
            [
              { text: "Concepto", bold: true, alignment: "left" },
              { text: "Nº de días", bold: true, alignment: "center" },
              { text: "Preço por día", bold: true, alignment: "center" },
              { text: "Quantia", bold: true, alignment: "right" },
            ],
          ],
        },
        layout: "headerLineOnly",
      }:{
        margin: [0, 2, 0, 0],
        text: "",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*", 100],
          body: [
            [
              { text: "ORÇAMENTO TOTAL", bold: true, alignment: "right" },
              {
                text: modelReserva.importe + " €",
                bold: true,
                alignment: "right",
              },
            ],
            modelReserva.descuento != null &&
              modelReserva.descuento != "" &&
              modelReserva.descuento != 0.0
              ? [
                { text: "DESCONTO", bold: true, alignment: "right" },
                {
                  text: modelReserva.descuento + " €",
                  bold: true,
                  alignment: "right",
                },
              ]
              : ["", ""],

            [
              { text: "FIANÇA", bold: true, alignment: "right" },
              {
                text: modelReserva.fianza + " €",
                bold: true,
                alignment: "right",
              },
            ],

            [
              { text: "TOTAL A PAGAR", bold: true, alignment: "right" },
              {
                fillColor: "#00B0F0",
                text: modelReserva.total + " €",
                bold: true,
                alignment: "right",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        text: "(Preços com IVA incluído)", fontSize: 10
      },
      {
        text: "A caução é devolvida no final do aluguer", fontSize: 10,

      },
      {
        margin: [0, 5, 0, 0],
        text: "Método de pagamento:",
        fontSize: 10,
        italics: true,
        bold: true,
      },
      {
        margin: [0, 0, 0, 0],
        text: [
          "20% do orçamento, ",
          // { text: "sin la fianza", color: "#FF0000" },
          "para formalizar a reserva",
        ],
        fontSize: 10,
      },
      {
        margin: [0, 5, 0, 0],
        text: [
          "O valor pendente 6 dias úteis antes do início do aluguel (exceto entregas especiais)",
        ],
        fontSize: 10,
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "CAIXABANK    IBAN ES82 2100 4775 2502 0038 4614    BIC: CAIXESBBXXX",
                alignment: "left",
              },
            ]

          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "ABANCA          IBAN ES83 2080 0306 5130 4002 5574    BIC: CAGLESMMXXX",
                alignment: "left",
              },
            ]


          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "Cartão de crédito",
                alignment: "left",
              },
              {
                text: "",
              },
              {
                text: "",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],

        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                text: [
                  { fontSize: 10, text: "Opcional inclui sem custo:\n", bold: true },
                  { fontSize: 10, text: "Capacete\n" +
                  "Kit de punção\n" +
                  "Garrafa\n" +
                  "Alforjes \n" +
                  "Cadeado\n"}
                ],
                alignment: "left",
              },
              {
                text: [
                  { fontSize: 10, text: "Sob consulta com custo adicional:\n", bold: true },
                  { fontSize: 10, text: "Seguro todo riscos     7€/día\n" +
                  "Pedais SPD                  3€/día\n" +
                  "Bolsa frontal                3€/día\n" +
                  "Suporte móvel              5€\n" +
                  "Credencial                    5€\n"}
                ],
                alignment: "left",
              },

            ],
          ],
        },
        layout: "noBorders",

      },




      /*{
        width: "auto",
        fit: [800, 100],
        image: presupuestoImagen13,
      },*/

      {
        margin: [40, 10, 0, 0],
        width: "auto",
        fit: [800, 100],
        image: presupuestoImagen14,
      },
    ],
  };

  var fila = [
    { text: "S", alignment: "center" },
    {
      text: modelReserva.cant_bicis_s > 0 ? modelReserva.cant_bicis_s : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_s > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_s > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_s > 0 ? importe_s + " €" : " - €",
      alignment: "right",
    },
  ];

  if (modelReserva.cant_bicis_s > 0) {
    docDefinition.content[22].table.body.push(fila);
  }


  fila = [
    { text: "M", alignment: "center" },
    {
      text: modelReserva.cant_bicis_m > 0 ? modelReserva.cant_bicis_m : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_m > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_m > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_m > 0 ? importe_m + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_m > 0) {
    docDefinition.content[22].table.body.push(fila);
  }
  fila = [
    { text: "L", alignment: "center" },
    {
      text: modelReserva.cant_bicis_l > 0 ? modelReserva.cant_bicis_l : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_l > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_l > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_l > 0 ? importe_l + " €" : " -€",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_l > 0) {
    docDefinition.content[22].table.body.push(fila);
  }
  fila = [
    { text: "XL", alignment: "center" },
    {
      text: modelReserva.cant_bicis_xl > 0 ? modelReserva.cant_bicis_xl : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_xl > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_xl > 0 ? modelReserva.precio + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_xl > 0 ? importe_xl + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_xl > 0) {
    docDefinition.content[22].table.body.push(fila);
  }

  fila = [
    { text: "MS", alignment: "center" },
    {
      text: modelReserva.cant_bicis_ms > 0 ? modelReserva.cant_bicis_ms : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_ms > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_ms > 0 ? modelReserva.precio_m + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_ms > 0 ? importe_ms + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_ms > 0) {
    docDefinition.content[22].table.body.push(fila);
  }

  fila = [
    { text: "MM", alignment: "center" },
    {
      text: modelReserva.cant_bicis_mm > 0 ? modelReserva.cant_bicis_mm : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_mm > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_mm > 0 ? modelReserva.precio_m + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_mm > 0 ? importe_mm + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_mm > 0) {
    docDefinition.content[22].table.body.push(fila);
  }

  fila = [
    { text: "ML", alignment: "center" },
    {
      text: modelReserva.cant_bicis_ml > 0 ? modelReserva.cant_bicis_ml : "",
      alignment: "center",
    },
    {
      text: modelReserva.cant_bicis_ml > 0 ? modelReserva.cant_dias : "",
      alignment: "center",
    },
    {
      text:
        modelReserva.cant_bicis_ml > 0 ? modelReserva.precio_m + " €" : " - €",
      alignment: "right",
    },
    {
      text: modelReserva.cant_bicis_ml > 0 ? importe_ml + " €" : " - €",
      alignment: "right",
    },
  ];
  if (modelReserva.cant_bicis_ml > 0) {
    docDefinition.content[22].table.body.push(fila);
  }

  if (modelReserva.pedales_automaticos) {
    docDefinition.content[26].table.body.push([
      { text: "Pedales SPD (Automáticos)", alignment: "left" },
      { text: modelReserva.cant_dias, alignment: "center" },
      { text: "3 €", alignment: "center" },
      { text: modelReserva.pedales_automaticos_importe + " €", alignment: "right" },
    ]);
  }

  if (modelReserva.seguro) {
    docDefinition.content[26].table.body.push([
      { text: "Seguro Todo Riesgo", alignment: "left" },
      { text: modelReserva.cant_dias, alignment: "center" },
      { text: "7 €", alignment: "center" },
      { text: modelReserva.seguro_importe + " €", alignment: "right" },
    ]);
  }

  if (modelReserva.bolsa_delantera) {
    docDefinition.content[26].table.body.push([
      { text: "Bolsa delantera", alignment: "left" },
      { text: modelReserva.cant_dias, alignment: "center" },
      { text: "3 €", alignment: "center" },
      { text: modelReserva.bolsa_delantera_importe + " €", alignment: "right" },
    ]);
  }

  if (modelReserva.soporte_movil) {
    docDefinition.content[26].table.body.push([
      { text: "Soporte móvil", alignment: "left" },
      { text: "", alignment: "center" },
      { text: "5 €", alignment: "center" },
      { text: modelReserva.soporte_movil_importe + " €", alignment: "right" },
    ]);
  }

  if (modelReserva.credencial) {
    docDefinition.content[26].table.body.push([
      { text: "Credencial", alignment: "left" },
      { text: "", alignment: "center" },
      { text: "5 €", alignment: "center" },
      { text: modelReserva.credencial_importe + " €", alignment: "right" },
    ]);
  }

  return _filtrarSoloPaginaPrincipalPresupuesto(
    docDefinition,
    modelReserva,
    imprimirSoloPaginaPrincipal
  );
}



export async function reporteConfirmacion(
  context,
  [
    con_condiciones,
    modelReserva,
    presupuestoImagen7,
    imagenFirma,
    importe_s,
    importe_m,
    importe_l,
    importe_xl,
    importe_ms,
    importe_mm,
    importe_ml,
    campoConfirmacionFecha,
    campoConfirmacionObservaciones,
    complementos_importe
  ]
) {
  var docDefinition = {
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 20],

    content: [
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ["*", 80],
          body: [
            [
              {
                table: {
                  widths: ["*"],
                  body: [
                    [
                      {
                        fontSize: 18,
                        text: "Confirmación Reserva Alquiler",
                        bold: true,
                        alignment: "left",
                      },
                    ],
                    [
                      {
                        text: "www.ebikecompostela.es                info@ebikecompostela.es",
                        alignment: "left",
                        color: "#1E88E5",
                      },
                    ],
                    [
                      {
                        text: "C/Manuel María nº 10- Santiago de Compostela",
                        alignment: "left",
                        color: "#375623",
                      },
                    ],
                    [
                      {
                        text: "Teléfono de contacto: 699 331 965  -  627 632 258",
                        alignment: "left",
                        color: "#375623",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },

              {
                width: "auto",
                fit: [80, 100],
                image: presupuestoImagen7,
                alignment: "left",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [120, "*"],
          body: [
            [
              {
                colSpan: 2,
                border: [false, false, false, true],
                fontSize: 14,
                text: "ALQUILER DE BICICLETA ELÉCTRICA O MUSCULAR",
                bold: true,
                alignment: "left",
              },
              "",
            ],
            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Fecha de Reserva: ",
                bold: true,
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: _captionFecha(campoConfirmacionFecha),
                bold: true,
              },
            ],
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Presupuesto: ",
                bold: true,
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cod_presupuesto,
                bold: true,
              },
            ],
            [
              {
                colSpan: 2,
                border: [false, false, false, false],
                fontSize: 10,
                text: "Datos Cliente: ",
                bold: true,
              },
              "",
            ],
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Nombre:",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: modelReserva.cliente.nombre,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "D.N.I:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.cliente.dni,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Dirección:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.cliente.domicilio,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Teléfono Contacto:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.cliente.telefono,
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "Email:",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                text: modelReserva.cliente.email,
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        fontSize: 10,
        text: "Datos Alquiler:",
        bold: true,
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [120, 80, "*", 20, 20, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Inicio Alquiler:",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: _captionFecha(modelReserva.fecha_inicial),
                alignment: "left",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_s > 0 ?
                    "S" : "",
                alignment: "center",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_s > 0
                    ? modelReserva.cant_bicis_s
                    : "",
                alignment: "center",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Fin Alquiler:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: _captionFecha(modelReserva.fecha_final),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "TALLA:",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_m > 0
                  ? "M" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_m > 0
                    ? modelReserva.cant_bicis_m
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Numero de Ebikes:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis,
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_l > 0
                  ? "L" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_l > 0
                    ? modelReserva.cant_bicis_l
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_xl > 0
                  ? "XL" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_xl > 0
                    ? modelReserva.cant_bicis_xl
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_ms > 0
                  ? "MS" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_ms > 0
                    ? modelReserva.cant_bicis_ms
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Lugar de Entrega:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.ubicacion_inicial,
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_mm > 0
                  ? "MM" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_mm > 0
                    ? modelReserva.cant_bicis_mm
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "Lugar de Recogida:",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text: modelReserva.ubicacion_final,
              },
              {
                border: [false, false, false, true],
                text: "",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text: modelReserva.cant_bicis_ml > 0
                  ? "ML" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_ml > 0
                    ? modelReserva.cant_bicis_ml
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, true],
                text: "",
              },
            ],
          ],
        },
      },

      {
        margin: [0, 20, 0, 0],
        fontSize: 10,
        text: "Datos Adicionales:",
        bold: true,
      },

      {
        table: {
          widths: [120, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Observaciones:",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: campoConfirmacionObservaciones,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                text: "",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [120, 40, 80, 80, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "TARIFA:",
                bold: true,
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "Nº",
                bold: true,
                alignment: "left",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "PVP   ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: "TOTAL   ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "ALQUILER EBIKE",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_dias * (modelReserva.cant_bicis_s + modelReserva.cant_bicis_m +
                  modelReserva.cant_bicis_l + modelReserva.cant_bicis_xl),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.precio,
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text:
                  parseFloat(
                    parseFloat(importe_s) +
                    parseFloat(importe_m) +
                    parseFloat(importe_l) +
                    parseFloat(importe_xl)
                  ).toFixed(2) + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "ALQUILER MUSC",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_dias * (modelReserva.cant_bicis_ms + modelReserva.cant_bicis_mm + modelReserva.cant_bicis_ml),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.precio_m,
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text:
                  parseFloat(parseFloat(importe_ms) +
                    parseFloat(importe_mm) +
                    parseFloat(importe_ml)
                  ).toFixed(2) + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "TRANSPORTE",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.transporte_importe + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "COMPLEMENTOS",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: parseFloat(complementos_importe).toFixed(2) + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [true, false, false, false],
                fontSize: 10,
                text: "FIANZA",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "right",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.fianza + " €",
                alignment: "right",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            modelReserva.descuento != null &&
              modelReserva.descuento != "" &&
              modelReserva.descuento != 0.0
              ? [
                {
                  margin: [0, 0, 0, 20],
                  border: [true, false, false, true],
                  fontSize: 10,
                  text: "DESCUENTO",
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, false, false, true],
                  fontSize: 10,
                  text: "",
                  alignment: "center",
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, false, false, true],
                  fontSize: 10,
                  text: "",
                  alignment: "right",
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, false, true, true],
                  fontSize: 10,
                  text: modelReserva.descuento + " €",
                  alignment: "right",
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, false, false, false],
                  text: "",
                },
              ]
              : [
                {
                  border: [true, false, false, true],
                  fontSize: 10,
                  text: "",
                },
                {
                  border: [false, false, false, true],
                  fontSize: 10,
                  text: "",
                },
                {
                  border: [false, false, false, true],
                  fontSize: 10,
                  text: "",
                },
                {
                  border: [false, false, true, true],
                  fontSize: 10,
                  text: "",
                },
                {
                  border: [false, false, false, false],
                  text: "",
                },
              ],

            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "PAGADO ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                fillColor: "#B3C6E7",
                text: modelReserva.pagado + " €",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "PENDIENTE ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                fillColor: "#B3C6E7",
                text: modelReserva.pendiente + " €",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 5, 0, 0],
        text: "Forma de pago:",
        fontSize: 10,
        italics: true,
        bold: true,
      },
      {
        margin: [0, 0, 0, 0],
        text: [
          "20% del presupuesto, ",
          // { text: "sin la fianza", color: "#FF0000" },
          "para formalizar la reserva.",
        ],
        fontSize: 10,
      },
      {
        margin: [0, 5, 0, 0],
        text: [
          "El importe pendiente 6 días hábiles antes del inicio del alquiler (Salvo entregas especiales).",
        ],
        fontSize: 10,
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "CAIXABANK    IBAN ES82 2100 4775 2502 0038 4614    BIC: CAIXESBBXXX",
                alignment: "left",
              },
            ]

          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "ABANCA          IBAN ES83 2080 0306 5130 4002 5574    BIC: CAGLESMMXXX",
                alignment: "left",
              },
            ]


          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "Bizum 699 331 965",
                alignment: "left",
              },
              {
                text: "",
              },
              {
                text: "",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      con_condiciones
        ? {
          margin: [0, 30, 0, 0],
          table: {
            widths: ["*", "*"],
            body: [
              [
                {
                  colSpan: 2,
                  margin: [0, 60, 0, 20],
                  fontSize: 18,
                  text: "\n\nTÉRMINOS Y CONDICIONES:",
                  bold: true,
                  alignment: "left",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "1.- Las bicicletas se recogerán y entregarán en el horario establecido que va desde las 08:00 horas a las 21:00 horas todos los días de la semana.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: [
                    "2.- La devolución de la/s bicicleta/ y material alquilado se llevará a cabo en el lugar del arrendamiento, el día ",
                    {
                      text: _captionFecha(modelReserva.fecha_final),
                      fontSize: 10,
                      bold: true,
                    },
                    " a la hora 21:00. El incumplimiento de la hora de entrega ocasionará un cargo adicional al cliente de 10 euros por hora de retraso. De no realizar la entrega en el día estipulado en el contrato, el cargo adicional ocasionado, será de 35 euros. Al no realizar la entrega, el arrendador podrá tomar posesión inmediata la bicicleta en el lugar donde se encuentre, sin tener derecho a reclamación alguna por parte del arrendatario.",
                  ],
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "3.- La franja horaria de alquiler queda comprendida: Día completo: 08:00 a 21:00 horas.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "4.- El material se devolverá completo y en el mismo estado en el que se le entregó al cliente. El coste por reparación o reposición de la bicicleta y/o del material correrá a cargo del cliente. El cliente deberá informar al arrendador, de los daños ocasionados en dicho material o del mal funcionamiento del mismo. El cliente esta obligado a tener buen cuidado y tomar todas las precauciones necesarias para proteger las bicicletas y el equipo alquilado de daños, perdida o robo. De producirse cualquiera de las mencionadas situaciones durante el periodo de alquiler, el cliente asumirá de manera inmediata la totalidad de los costes de reposición ocasionados a precio de tarifa o de mercado según el arrendador disponga o no de la pieza a reponer. Al final del periodo de alquiler el arrendador, determinará las condiciones de entrega del material alquilado y valorará dado el caso, las pérdidas o daños ocasionados. El cliente está obligado en todo momento a fijar correctamente con el candado y cadena de seguridad la/s bicicleta/s cuando no las tenga a la vista (pasar el candado por el cuadro, sillín y ruedas y atar la bicicleta aun poste fijado al suelo o bici parking).",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "5.- El arrendatario declara estar en perfectas condiciones de salud, ser capaz de manejar una bicicleta y poseer el control necesario del equipamiento alquilado.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: [
                    "6.- En este acto el arrendatario entrega al arrendador, una ",
                    {
                      text: "fianza de " + modelReserva.fianza + " euros",
                      fontSize: 10,
                      bold: true,
                    },
                    " que servirá para responder de los posibles daños causados a la bicicleta o el equipamiento alquilado, dicha fianza será reembolsada al finalizar el contrato. En caso de pérdida o robo de la bicicleta, el arrendador perderá todo el derecho a la fianza, debiendo comunicar de inmediato tal circunstancia. Además, deberá proceder a indemnizar al arrendatario por la cantidad estipulada según precio de mercado.",
                  ],
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "7.- El alquiler de bicicleta no incluye seguro de daños propios, por lo que el arrendatario es responsable de todos los daños de material o personales que pueda sufrir. El alquiler se realiza con la cobertura del correspondiente seguro de RC que cubre todos los daños causados por origen del alquiler a terceros, personas o bienes. Es responsabilidad del cliente y de su/s acompañante/s respetar las normas de tráfico españolas y conducir con cuidado y respetar a los peatones.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "8.- Los datos facilitados por el cliente, serán utilizados exclusivamente para la correcta prestación del servicio contratado, pudiendo solicitar, de acuerdo con la ley, su acceso, rectificación, cancelación u oposición mediante comunicación por cualquier medio al arrendador. Este contrato se rige por la ley española.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "9.- En caso de que el arrendador necesite asistencía en viaje sin que hubiese sido contratada con anterioridad, el coste será de 15€ hora, y 15€ de desplazamiento a la zona donde se encuentre el cliente.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "10.- En caso de que el arrendador decida devolver las bicicletas en fecha anterior a la finalizacion de este contrato, no tendrá derecho a la devolución alguna.",
                },
                "",
              ],
              [
                {
                  margin: [0, 40, 0, 0],
                  fontSize: 10,
                  bold: true,
                  text: "Firma del Arrendador",
                },
                {
                  margin: [0, 40, 0, 0],
                  fontSize: 10,
                  bold: true,
                  text: "Firma del Arrendatario - Contratante",
                },
              ],

              [
                {
                  width: "auto",
                  fit: [180, 100],
                  image: imagenFirma,
                  alignment: "left",
                },

                {
                  text: "",
                },
              ],
            ],
          },
          layout: "noBorders",
        }
        : "",
    ],
  };

  return docDefinition;
}

export async function reporteConfirmacionIngles(
  context,
  [
    con_condiciones,
    modelReserva,
    presupuestoImagen7,
    imagenFirma,
    importe_s,
    importe_m,
    importe_l,
    importe_xl,
    importe_ms,
    importe_mm,
    importe_ml,
    campoConfirmacionFecha,
    campoConfirmacionObservaciones,
    complementos_importe
  ]
) {
  var docDefinition = {
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 20],

    content: [
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ["*", 80],
          body: [
            [
              {
                table: {
                  widths: ["*"],
                  body: [
                    [
                      {
                        fontSize: 18,
                        text: "Booking Boucher",
                        bold: true,
                        alignment: "left",
                      },
                    ],
                    [
                      {
                        text: "www.ebikecompostela.es                info@ebikecompostela.es",
                        alignment: "left",
                        color: "#1E88E5",
                      },
                    ],
                    [
                      {
                        text: "C/Manuel María nº 10- Santiago de Compostela",
                        alignment: "left",
                        color: "#375623",
                      },
                    ],
                    [
                      {
                        text: "Teléfono contacto: 699 331 965  -  627 632 258",
                        alignment: "left",
                        color: "#375623",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },

              {
                width: "auto",
                fit: [80, 100],
                image: presupuestoImagen7,
                alignment: "left",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [120, "*"],
          body: [
            [
              {
                colSpan: 2,
                border: [false, false, false, true],
                fontSize: 14,
                text: "ELECTRIC BIKE RENTAL",
                bold: true,
                alignment: "left",
              },
              "",
            ],
            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Date: ",
                bold: true,
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: _captionFecha(campoConfirmacionFecha),
                bold: true,
              },
            ],
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Nº Budget: ",
                bold: true,
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cod_presupuesto,
                bold: true,
              },
            ],
            [
              {
                colSpan: 2,
                border: [false, false, false, false],
                fontSize: 10,
                text: "Customer Information: ",
                bold: true,
              },
              "",
            ],
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Name and Surname:",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: modelReserva.cliente.nombre,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Nº Passport:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.cliente.dni,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Address:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.cliente.domicilio,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Phone number:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.cliente.telefono,
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "Email:",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                text: modelReserva.cliente.email,
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        fontSize: 10,
        text: "Rental data:",
        bold: true,
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [120, 80, "*", 20, 20, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Start Rent:",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: _captionFecha(modelReserva.fecha_inicial),
                alignment: "left",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_s > 0 ?
                    "S" : "",
                alignment: "center",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_s > 0
                    ? modelReserva.cant_bicis_s
                    : "",
                alignment: "center",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Finish Rent:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: _captionFecha(modelReserva.fecha_final),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Sizes:",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_m > 0
                  ? "M" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_m > 0
                    ? modelReserva.cant_bicis_m
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Number of bikes:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis,
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_l > 0
                  ? "L" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_l > 0
                    ? modelReserva.cant_bicis_l
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_xl > 0
                  ? "XL" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_xl > 0
                    ? modelReserva.cant_bicis_xl
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_ms > 0
                  ? "MS" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_ms > 0
                    ? modelReserva.cant_bicis_ms
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Place of delivery:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.ubicacion_inicial,
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_mm > 0
                  ? "MM" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_mm > 0
                    ? modelReserva.cant_bicis_mm
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "Pickup location:",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text: modelReserva.ubicacion_final,
              },
              {
                border: [false, false, false, true],
                text: "",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text: modelReserva.cant_bicis_ml > 0
                  ? "ML" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_ml > 0
                    ? modelReserva.cant_bicis_ml
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, true],
                text: "",
              },
            ],
          ],
        },
      },

      {
        margin: [0, 20, 0, 0],
        fontSize: 10,
        text: "Additional information:",
        bold: true,
      },

      {
        table: {
          widths: [120, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Observations:",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: campoConfirmacionObservaciones,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                text: "",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [120, 40, 80, 80, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "PRICES:",
                bold: true,
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "Nº",
                bold: true,
                alignment: "left",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "PVP   ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: "TOTAL   ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "RENT EBIKE",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_dias * (modelReserva.cant_bicis_s + modelReserva.cant_bicis_m +
                  modelReserva.cant_bicis_l + modelReserva.cant_bicis_xl),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.precio,
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text:
                  parseFloat(
                    parseFloat(importe_s) +
                    parseFloat(importe_m) +
                    parseFloat(importe_l) +
                    parseFloat(importe_xl)
                  ).toFixed(2) + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "RENT MUSC",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_dias * (modelReserva.cant_bicis_ms + modelReserva.cant_bicis_mm + modelReserva.cant_bicis_ml),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.precio_m,
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text:
                  parseFloat(parseFloat(importe_ms) +
                    parseFloat(importe_mm) +
                    parseFloat(importe_ml)
                  ).toFixed(2) + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "TRANSPORTATION",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.transporte_importe + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "COMPLEMENTS",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: parseFloat(complementos_importe).toFixed(2) + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [true, false, false, false],
                fontSize: 10,
                text: "DEPOSIT",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "right",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.fianza + " €",
                alignment: "right",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            modelReserva.descuento != null &&
              modelReserva.descuento != "" &&
              modelReserva.descuento != 0.0
              ? [
                {
                  margin: [0, 0, 0, 20],
                  border: [true, false, false, true],
                  fontSize: 10,
                  text: "DISCOUNT",
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, false, false, true],
                  fontSize: 10,
                  text: "",
                  alignment: "center",
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, false, false, true],
                  fontSize: 10,
                  text: "",
                  alignment: "right",
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, false, true, true],
                  fontSize: 10,
                  text: modelReserva.descuento + " €",
                  alignment: "right",
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, false, false, false],
                  text: "",
                },
              ]
              : [
                {
                  border: [true, false, false, true],
                  fontSize: 10,
                  text: "",
                },
                {
                  border: [false, false, false, true],
                  fontSize: 10,
                  text: "",
                },
                {
                  border: [false, false, false, true],
                  fontSize: 10,
                  text: "",
                },
                {
                  border: [false, false, true, true],
                  fontSize: 10,
                  text: "",
                },
                {
                  border: [false, false, false, false],
                  text: "",
                },
              ],

            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [true, false, false, true],
                fontSize: 8,
                text: "PAID OUT ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                fillColor: "#B3C6E7",
                text: modelReserva.pagado + " €",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [true, false, false, true],
                fontSize: 8,
                text: "PENDING PAYMENT ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                fillColor: "#B3C6E7",
                text: modelReserva.pendiente + " €",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 40, 0, 0],
        fontSize: 12,
        text: "PAYMENT METHOD:",
        italics: true,
        bold: true,
      },
      {
        margin: [0, 0, 0, 0],
        text: [
          "20% of the budget, ",
          // { text: "sin la fianza", color: "#FF0000" },
          "to formalize the reservation.",
        ],
        fontSize: 10,
      },
      {
        margin: [0, 5, 0, 0],
        text: [
          "The amount pending 6 business days before the start of rental (except special deliveries).",
        ],
        fontSize: 10,
      },
      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "CAIXABANK    IBAN ES82 2100 4775 2502 0038 4614    BIC: CAIXESBBXXX",
                alignment: "left",
              },
            ]

          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "ABANCA          IBAN ES83 2080 0306 5130 4002 5574    BIC: CAGLESMMXXX",
                alignment: "left",
              },
            ]


          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "CREDIT CARD",
                alignment: "left",
              },
              {
                text: "",
              },
              {
                text: "",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      con_condiciones
        ? {
          margin: [0, 30, 0, 0],
          table: {
            widths: ["*", "*"],
            body: [
              [
                {
                  colSpan: 2,
                  margin: [0, 60, 0, 20],
                  fontSize: 18,
                  text: "\n\nSPECIFIC TERMS & CONDITIONS OF THE CONTRACT ",
                  bold: true,
                  alignment: "left",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "1.- Bicycles will be picked up and brought back between the established schedule which goes from 8:00 to 21:00 every day of the week.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: [
                    "2.- The return of bicycles and any other rented material will take place at the place of rental,  On: ",
                    {
                      text: _captionFecha(modelReserva.fecha_final),
                      fontSize: 10,
                      bold: true,
                    },
                    " at 21:00. Failure to meet the delivery time will cause an additional charge to the client of 10 euros per hour of delay. If the delivery is not made on the day stipulated in the contract, the additional charge caused will be 35 euros. By not making the delivery, the lessor may take immediate possession of the bicycle in the place where it is located, without having the right to any claim by the lessee.",
                  ],
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "3.- The rental period is comprised of: Whole day: 8:00 to 21:00",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "4.- The rented material shall be returned in its entirety in the same state that the client received it. Cost for repair or replenishment of the bicycle and/or any other rented material will be client’s responsibility. They shall inform the lessor of caused damage or malfunction. They are obligated to maintain the rented material in good condition and take all necessary precaution to protect it from harm, loss and theft. If any of said situations were to happen during the lease period, the client will immediately assume the entirety of the replacement costs at tariff or market price, depending on whether or not the lessor has the part to be replaced. At the end of the lease period the lessor will determine return condition and they will assess, given the circumstances, the loss or damaged caused. The client will be obligated to verify their padlock and security chain are properly placed (pass the lock through the frame, saddle and wheels and tie the bike to a post fixed to the ground or bike parking). ",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "5.- The lessee declares they are in perfect health condition, are capable of riding a bicycle and poses necessary control over the rented material.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: [
                    "6.- In this act, the lessee submits the lessor a ",
                    {
                      text: modelReserva.fianza + " euros",
                      fontSize: 10,
                      bold: true,
                    },
                    " bail trough credit card which will be used as collateral for any possible damage and shall be refunded at the end of the lease. In case of loss or theft of the bicycle, the lessee will lose all right to the bail, having to communicate said circumstance right away. Moreover, they must compensate the lessor for the stipulated amount accorded to market price.",
                  ],
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "7.- This lease does not include own damage insurance, so the lessee is responsible for all material or personal damage they may suffer. The rental includes the corresponding liability insurance that covers all damages caused by the rental to third parties, people or goods. The client and their companions must obey Spanish traffic regulations, drive safely and respect pedestrians.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "8.- The data provided by the customer will be exclusively used to guarantee the correct service provision, being always able to request access, rectification, cancellation or objection by communicating with the lessor, according to the law.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "9.- In the event that the lessee needs travel assistance without having contracted it beforehand, the cost will be of 15€ per hour and 15€ to go where the client is located.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "10.- In the event that the lessee decides to return the rented equipment on a date before the end of the contract expires, they will not be entitled to any refund.",
                },
                "",
              ],
              [
                {
                  margin: [0, 40, 0, 0],
                  fontSize: 10,
                  bold: true,
                  text: "Lessor’s Signature        ",
                },
                {
                  margin: [0, 40, 0, 0],
                  fontSize: 10,
                  bold: true,
                  text: "Customer Signature",
                },
              ],

              [
                {
                  width: "auto",
                  fit: [180, 100],
                  image: imagenFirma,
                  alignment: "left",
                },

                {
                  text: "",
                },
              ],
            ],
          },
          layout: "noBorders",
        }
        : "",
    ],
  };

  return docDefinition;
}

export async function reporteConfirmacionPortugues(
  context,
  [
    con_condiciones,
    modelReserva,
    presupuestoImagen7,
    imagenFirma,
    importe_s,
    importe_m,
    importe_l,
    importe_xl,
    importe_ms,
    importe_mm,
    importe_ml,
    campoConfirmacionFecha,
    campoConfirmacionObservaciones,
    complementos_importe
  ]
) {
  var docDefinition = {
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 20],

    content: [
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ["*", 80],
          body: [
            [
              {
                table: {
                  widths: ["*"],
                  body: [
                    [
                      {
                        fontSize: 18,
                        text: "Confirmação de Reserva de Aluguel",
                        bold: true,
                        alignment: "left",
                      },
                    ],
                    [
                      {
                        text: "www.ebikecompostela.es                info@ebikecompostela.es",
                        alignment: "left",
                        color: "#1E88E5",
                      },
                    ],
                    [
                      {
                        text: "C/Manuel María nº 10- Santiago de Compostela",
                        alignment: "left",
                        color: "#375623",
                      },
                    ],
                    [
                      {
                        text: "Telefone de contato: 699 331 965  -  627 632 258",
                        alignment: "left",
                        color: "#375623",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },

              {
                width: "auto",
                fit: [80, 100],
                image: presupuestoImagen7,
                alignment: "left",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [120, "*"],
          body: [
            [
              {
                colSpan: 2,
                border: [false, false, false, true],
                fontSize: 14,
                text: "ALUGUER DE BICICLETA ELÉTRICA OU MUSCULARES",
                bold: true,
                alignment: "left",
              },
              "",
            ],
            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Data da Reserva: ",
                bold: true,
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: _captionFecha(campoConfirmacionFecha),
                bold: true,
              },
            ],
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Nº do orçamento:",
                bold: true,
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cod_presupuesto,
                bold: true,
              },
            ],
            [
              {
                colSpan: 2,
                border: [false, false, false, false],
                fontSize: 10,
                text: "Datos do Cliente: ",
                bold: true,
              },
              "",
            ],
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Nome:",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: modelReserva.cliente.nombre,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Nº D.N.I.:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.cliente.dni,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Endereço:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.cliente.domicilio,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Telefone de contato:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.cliente.telefono,
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "Email:",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                text: modelReserva.cliente.email,
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        fontSize: 10,
        text: "Dados de aluguel:",
        bold: true,
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [120, 80, "*", 20, 20, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Início do Aluguel",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: _captionFecha(modelReserva.fecha_inicial),
                alignment: "left",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_s > 0 ?
                    "S" : "",
                alignment: "center",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_s > 0
                    ? modelReserva.cant_bicis_s
                    : "",
                alignment: "center",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Fim do Aluguel:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: _captionFecha(modelReserva.fecha_final),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "TALLAS:",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_m > 0
                  ? "M" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_m > 0
                    ? modelReserva.cant_bicis_m
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Numero de Ebikes:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis,
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_l > 0
                  ? "L" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_l > 0
                    ? modelReserva.cant_bicis_l
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_xl > 0
                  ? "XL" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_xl > 0
                    ? modelReserva.cant_bicis_xl
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_ms > 0
                  ? "MS" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_ms > 0
                    ? modelReserva.cant_bicis_ms
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Lugar de Entrega:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.ubicacion_inicial,
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_mm > 0
                  ? "MM" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_mm > 0
                    ? modelReserva.cant_bicis_mm
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "Lugar de Recogida:",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text: modelReserva.ubicacion_final,
              },
              {
                border: [false, false, false, true],
                text: "",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text: modelReserva.cant_bicis_ml > 0
                  ? "ML" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_ml > 0
                    ? modelReserva.cant_bicis_ml
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, true],
                text: "",
              },
            ],
          ],
        },
      },

      {
        margin: [0, 20, 0, 0],
        fontSize: 10,
        text: "Dados adicionais:",
        bold: true,
      },

      {
        table: {
          widths: [120, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Observações",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: campoConfirmacionObservaciones,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                text: "",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [120, 40, 80, 80, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "TAXA:",
                bold: true,
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "Nº",
                bold: true,
                alignment: "left",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "PVP   ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: "TOTAL   ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "ALUGUEL ELÉCTRICA",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_dias * (modelReserva.cant_bicis_s + modelReserva.cant_bicis_m +
                  modelReserva.cant_bicis_l + modelReserva.cant_bicis_xl),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.precio,
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text:
                  parseFloat(
                    parseFloat(importe_s) +
                    parseFloat(importe_m) +
                    parseFloat(importe_l) +
                    parseFloat(importe_xl)
                  ).toFixed(2) + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "ALUGUEL MUSC",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_dias * (modelReserva.cant_bicis_ms + modelReserva.cant_bicis_mm + modelReserva.cant_bicis_ml),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.precio_m,
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text:
                  parseFloat(parseFloat(importe_ms) +
                    parseFloat(importe_mm) +
                    parseFloat(importe_ml)
                  ).toFixed(2) + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "TRANSPORTE",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.transporte_importe + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "COMPLEMENTS",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "right",
              },
              {
                border: [false, false, true, false],  
                fontSize: 10,
                text: parseFloat(complementos_importe).toFixed(2) + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [true, false, false, false],
                fontSize: 10,
                text: "FIANÇA",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "right",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.fianza + " €",
                alignment: "right",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            modelReserva.descuento != null &&
              modelReserva.descuento != "" &&
              modelReserva.descuento != 0.0
              ? [
                {
                  margin: [0, 0, 0, 20],
                  border: [true, false, false, true],
                  fontSize: 10,
                  text: "DESCONTO",
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, false, false, true],
                  fontSize: 10,
                  text: "",
                  alignment: "center",
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, false, false, true],
                  fontSize: 10,
                  text: "",
                  alignment: "right",
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, false, true, true],
                  fontSize: 10,
                  text: modelReserva.descuento + " €",
                  alignment: "right",
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, false, false, false],
                  text: "",
                },
              ]
              : [
                {
                  border: [true, false, false, true],
                  fontSize: 10,
                  text: "",
                },
                {
                  border: [false, false, false, true],
                  fontSize: 10,
                  text: "",
                },
                {
                  border: [false, false, false, true],
                  fontSize: 10,
                  text: "",
                },
                {
                  border: [false, false, true, true],
                  fontSize: 10,
                  text: "",
                },
                {
                  border: [false, false, false, false],
                  text: "",
                },
              ],

            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "PAGADO ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                fillColor: "#B3C6E7",
                text: modelReserva.pagado + " €",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "PENDENTE ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                fillColor: "#B3C6E7",
                text: modelReserva.pendiente + " €",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 40, 0, 0],
        fontSize: 12,
        text: "Mótodo de pagamento:",
        italics: true,
        bold: true,
      },
      {
        margin: [0, 0, 0, 0],
        text: [
          "20% do orçamento, ",
          // { text: "sin la fianza", color: "#FF0000" },
          "para formalizar a reserva.",
        ],
        fontSize: 10,
      },
      {
        margin: [0, 5, 0, 0],
        text: [
          "O valor pendente 6 dias úteis antes do início do aluguel (exceto entregas especiais)",
        ],
        fontSize: 10,
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "CAIXABANK    IBAN ES82 2100 4775 2502 0038 4614    BIC: CAIXESBBXXX",
                alignment: "left",
              },
            ]

          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "ABANCA          IBAN ES83 2080 0306 5130 4002 5574    BIC: CAGLESMMXXX",
                alignment: "left",
              },
            ]


          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "Cartão de crédito",
                alignment: "left",
              },
              {
                text: "",
              },
              {
                text: "",
              },
            ],
          ],
        },
        layout: "noBorders",
      },
      con_condiciones
        ? {
          margin: [0, 30, 0, 0],
          table: {
            widths: ["*", "*"],
            body: [
              [
                {
                  colSpan: 2,
                  margin: [0, 60, 0, 20],
                  fontSize: 18,
                  text: "\n\nTERMOS E CONDIÇÕES:",
                  bold: true,
                  alignment: "left",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "1.- As bicicletas serão recolhidas e entregues no horário estabelecido, que funciona das 8h00 às 21h00 todos os dias da semana.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: [
                    "2.- A devolução da(s) bicicleta(s) e equipamentos alugados ocorrerá no local de locação, no dia",
                    {
                      text: _captionFecha(modelReserva.fecha_final),
                      fontSize: 10,
                      bold: true,
                    },
                    " às 21h. O incumprimento do prazo de entrega acarretará um custo adicional ao cliente de 10 euros por hora de atraso. Caso a entrega não seja efectuada no dia estipulado no contrato, o custo adicional incorrido será de 35 euros. Ao não entregar a bicicleta, o locador poderá tomar imediatamente posse da bicicleta no local onde esta se encontre, sem ter direito a qualquer reclamação por parte do locatário.",
                  ],
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "3.- O horário de locação está incluído: Dia inteiro: 08h00 às 21h00.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "4.- O material será devolvido completo e nas mesmas condições em que foi entregue ao cliente. Os custos de reparação ou substituição da bicicleta e/ou material serão suportados pelo cliente. O cliente deverá informar o locador de qualquer dano causado ao referido material ou do seu mau funcionamento. O cliente obriga-se a ter bons cuidados e tomar todas as precauções necessárias para proteger as bicicletas e equipamentos alugados contra danos, perdas ou roubos. Se ocorrer alguma das situações acima mencionadas durante o período de aluguer, o cliente assumirá imediatamente todos os custos de substituição incorridos à taxa ou preço de mercado, dependendo se o locador tem ou não a peça a substituir. No final do período de aluguer, o locador determinará as condições de entrega do material alugado e avaliará, se for o caso, eventuais perdas ou danos causados. O cliente obriga-se sempre a fixar corretamente a(s) bicicleta(s) com o cadeado e a corrente de segurança quando estes não estiverem visíveis (passar o cadeado pelo quadro, selim e rodas e amarrar a bicicleta a um poste fixado ao solo). estacionamento de bicicletas).",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "5.- O locatário declara estar em perfeitas condições de saúde, saber manejar a bicicleta e ter o controle necessário do equipamento alugado.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: [
                    "6.- Neste acto o locatário entrega ao locador uma ",
                    {
                      text: "caução de " + modelReserva.fianza + " euros",
                      fontSize: 10,
                      bold: true,
                    },
                    " por cartão de crédito que servirá para responder por possíveis danos causados ​​à bicicleta ou ao equipamento alugado, caução que será devolvida no final do contrato. Em caso de perda ou roubo da bicicleta, o locador perderá todo o direito à caução, devendo comunicar imediatamente tal circunstância. Além disso, deverá proceder à compensação do inquilino pelo valor estipulado de acordo com o preço de mercado.",
                  ],
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "7.- O aluguer da bicicleta não inclui seguro contra danos, pelo que o locatário é responsável por todos os danos materiais ou pessoais que possa sofrer. O aluguer é efectuado com a cobertura do correspondente seguro de responsabilidade civil que cobre todos os danos causados ​​pelo aluguer a terceiros, pessoas ou bens. É da responsabilidade do cliente e do(s) seu(s) acompanhante(s) respeitar as regras de trânsito espanholas e conduzir com cuidado e respeitar os peões.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "8.- Os dados fornecidos pelo cliente serão utilizados exclusivamente para a correta prestação do serviço contratado, podendo solicitar, nos termos da lei, o seu acesso, retificação, cancelamento ou oposição, comunicando por qualquer meio ao locador. Este contrato é regido pela lei espanhola.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "9.- Caso o locador necessite de assistência em viagem sem ter sido previamente contratado, o custo será de 15€ por hora, e 15€ para deslocação até à zona onde o cliente se encontra.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "10.- Caso o locador decida devolver as bicicletas em data anterior ao final deste contrato, não você terá direito a qualquer reembolso.",
                },
                "",
              ],
              [
                {
                  margin: [0, 40, 0, 0],
                  fontSize: 10,
                  bold: true,
                  text: "Assinatura do Proprietário",
                },
                {
                  margin: [0, 40, 0, 0],
                  fontSize: 10,
                  bold: true,
                  text: "Assinatura do Locatário - Contratante",
                },
              ],

              [
                {
                  width: "auto",
                  fit: [180, 100],
                  image: imagenFirma,
                  alignment: "left",
                },

                {
                  text: "",
                },
              ],
            ],
          },
          layout: "noBorders",
        }
        : "",
    ],
  };

  return docDefinition;
}


export async function reporteConfirmacionAgencia(
  context,
  [
    con_condiciones,
    modelReserva,
    presupuestoImagen7,
    imagenFirma,
    importe_s,
    importe_m,
    importe_l,
    importe_xl,
    importe_ms,
    importe_mm,
    importe_ml,
    campoConfirmacionFecha,
    campoConfirmacionObservaciones,
    campoConfirmacionAgenciaClienteNombre,
    campoConfirmacionAgenciaClienteDNI,
    campoConfirmacionAgenciaClienteDomicilio,
    campoConfirmacionAgenciaClienteTelefono,
    campoConfirmacionAgenciaClienteEmail,
    complementos_importe
  ]
) {
  var docDefinition = {
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 20],

    content: [
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ["*", 80],
          body: [
            [
              {
                table: {
                  widths: ["*"],
                  body: [
                    [
                      {
                        fontSize: 18,
                        text: "Confirmación Reserva Alquiler",
                        bold: true,
                        alignment: "left",
                      },
                    ],
                    [
                      {
                        text: "www.ebikecompostela.es                info@ebikecompostela.es",
                        alignment: "left",
                        color: "#1E88E5",
                      },
                    ],
                    [
                      {
                        text: "C/Manuel María nº 10- Santiago de Compostela",
                        alignment: "left",
                        color: "#375623",
                      },
                    ],
                    [
                      {
                        text: "Teléfono de contacto: 699 331 965  -  627 632 258",
                        alignment: "left",
                        color: "#375623",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },

              {
                width: "auto",
                fit: [80, 100],
                image: presupuestoImagen7,
                alignment: "left",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [120, "*"],
          body: [
            [
              {
                colSpan: 2,
                border: [false, false, false, true],
                fontSize: 14,
                text: "ALQUILER DE BICICLETA ELÉCTRICA O MUSCULAR",
                bold: true,
                alignment: "left",
              },
              "",
            ],
            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Fecha de Reserva: ",
                bold: true,
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: _captionFecha(campoConfirmacionFecha),
                bold: true,
              },
            ],
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Presupuesto: ",
                bold: true,
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cod_presupuesto,
                bold: true,
              },
            ],
            
          ],
        },
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [90, "*", 90, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Datos Agencia:",
                bold: true,
              },
              {
                border: [false, true, false, false],
                text: "",
              },
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Datos Cliente:",
                bold: true,
              },
              {
                border: [false, true, true, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Nombre:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cliente.nombre,
              },
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Nombre:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: campoConfirmacionAgenciaClienteNombre,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "C.I.F.:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cliente.dni,
              },
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "D.N.I.:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: campoConfirmacionAgenciaClienteDNI,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Dirección:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cliente.domicilio,
              },
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Dirección:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: campoConfirmacionAgenciaClienteDomicilio,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Teléfono Contacto:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cliente.telefono,
              },
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Teléfono Contacto:",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: campoConfirmacionAgenciaClienteTelefono,
              },
            ],

            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "Email:",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text: modelReserva.cliente.email,
              },
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "Email:",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                text: campoConfirmacionAgenciaClienteEmail,
              },
            ],
            
          ],
        },
      },

      

      {
        margin: [0, 20, 0, 0],
        fontSize: 10,
        text: "Datos Alquiler:",
        bold: true,
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [120, 80, "*", 20, 20, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Inicio Alquiler:",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: _captionFecha(modelReserva.fecha_inicial),
                alignment: "left",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_s > 0 ?
                    "S" : "",
                alignment: "center",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_s > 0
                    ? modelReserva.cant_bicis_s
                    : "",
                alignment: "center",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Fin Alquiler:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: _captionFecha(modelReserva.fecha_final),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "TALLA:",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_m > 0
                  ? "M" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_m > 0
                    ? modelReserva.cant_bicis_m
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Numero de Ebikes:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis,
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_l > 0
                  ? "L" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_l > 0
                    ? modelReserva.cant_bicis_l
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_xl > 0
                  ? "XL" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_xl > 0
                    ? modelReserva.cant_bicis_xl
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_ms > 0
                  ? "MS" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_ms > 0
                    ? modelReserva.cant_bicis_ms
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "Lugar de Entrega:",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.ubicacion_inicial,
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_bicis_mm > 0
                  ? "MM" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_mm > 0
                    ? modelReserva.cant_bicis_mm
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "Lugar de Recogida:",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text: modelReserva.ubicacion_final,
              },
              {
                border: [false, false, false, true],
                text: "",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text: modelReserva.cant_bicis_ml > 0
                  ? "ML" : "",
                alignment: "center",
              },
              {
                border: [false, false, false, true],
                fontSize: 10,
                text:
                  modelReserva.cant_bicis_ml > 0
                    ? modelReserva.cant_bicis_ml
                    : "",
                alignment: "center",
              },
              {
                border: [false, false, true, true],
                text: "",
              },
            ],
          ],
        },
      },

      {
        margin: [0, 20, 0, 0],
        fontSize: 10,
        text: "Datos Adicionales:",
        bold: true,
      },

      {
        table: {
          widths: [120, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "Observaciones:",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: campoConfirmacionObservaciones,
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                text: "",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [120, 40, 80, 80, "*"],
          body: [
            [
              {
                border: [true, true, false, false],
                fontSize: 10,
                text: "TARIFA:",
                bold: true,
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "Nº",
                bold: true,
                alignment: "left",
              },
              {
                border: [false, true, false, false],
                fontSize: 10,
                text: "PVP   ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, true, true, false],
                fontSize: 10,
                text: "TOTAL   ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "ALQUILER EBIKE",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_dias * (modelReserva.cant_bicis_s + modelReserva.cant_bicis_m +
                  modelReserva.cant_bicis_l + modelReserva.cant_bicis_xl),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.precio,
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text:
                  parseFloat(
                    parseFloat(importe_s) +
                    parseFloat(importe_m) +
                    parseFloat(importe_l) +
                    parseFloat(importe_xl)
                  ).toFixed(2) + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "ALQUILER MUSC",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.cant_dias * (modelReserva.cant_bicis_ms + modelReserva.cant_bicis_mm + modelReserva.cant_bicis_ml),
                alignment: "left",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: modelReserva.precio_m,
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text:
                  parseFloat(parseFloat(importe_ms) +
                    parseFloat(importe_mm) +
                    parseFloat(importe_ml)
                  ).toFixed(2) + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "TRANSPORTE",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.transporte_importe + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [true, false, false, false],
                fontSize: 10,
                text: "COMPLEMENTOS",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "right",
              },
              {
                border: [false, false, true, false],
                fontSize: 10,
                text: parseFloat(complementos_importe).toFixed(2) + " €",
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [true, false, false, false],
                fontSize: 10,
                text: "FIANZA",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "center",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
                alignment: "right",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, true, false],
                fontSize: 10,
                text: modelReserva.fianza + " €",
                alignment: "right",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            modelReserva.descuento != null &&
              modelReserva.descuento != "" &&
              modelReserva.descuento != 0.0
              ? [
                {
                  margin: [0, 0, 0, 20],
                  border: [true, false, false, true],
                  fontSize: 10,
                  text: "DESCUENTO",
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, false, false, true],
                  fontSize: 10,
                  text: "",
                  alignment: "center",
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, false, false, true],
                  fontSize: 10,
                  text: "",
                  alignment: "right",
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, false, true, true],
                  fontSize: 10,
                  text: modelReserva.descuento + " €",
                  alignment: "right",
                },
                {
                  margin: [0, 0, 0, 20],
                  border: [false, false, false, false],
                  text: "",
                },
              ]
              : [
                {
                  border: [true, false, false, true],
                  fontSize: 10,
                  text: "",
                },
                {
                  border: [false, false, false, true],
                  fontSize: 10,
                  text: "",
                },
                {
                  border: [false, false, false, true],
                  fontSize: 10,
                  text: "",
                },
                {
                  border: [false, false, true, true],
                  fontSize: 10,
                  text: "",
                },
                {
                  border: [false, false, false, false],
                  text: "",
                },
              ],

            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "PAGADO ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                fillColor: "#B3C6E7",
                text: modelReserva.pagado + " €",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                border: [true, false, false, true],
                fontSize: 10,
                text: "PENDIENTE ",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, true, true],
                fontSize: 10,
                fillColor: "#B3C6E7",
                text: modelReserva.pendiente + " €",
                bold: true,
                alignment: "right",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 5, 0, 0],
        text: "Forma de pago:",
        fontSize: 10,
        italics: true,
        bold: true,
      },
      {
        margin: [0, 0, 0, 0],
        text: [
          "20% del presupuesto, ",
          // { text: "sin la fianza", color: "#FF0000" },
          "para formalizar la reserva.",
        ],
        fontSize: 10,
      },
      {
        margin: [0, 5, 0, 0],
        text: [
          "El importe pendiente 6 días hábiles antes del inicio del alquiler (Salvo entregas especiales).",
        ],
        fontSize: 10,
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "CAIXABANK    IBAN ES82 2100 4775 2502 0038 4614    BIC: CAIXESBBXXX",
                alignment: "left",
              },
            ]

          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "ABANCA          IBAN ES83 2080 0306 5130 4002 5574    BIC: CAGLESMMXXX",
                alignment: "left",
              },
            ]


          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["*", "*", "*"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                text: "Bizum 699 331 965",
                alignment: "left",
              },
              {
                text: "",
              },
              {
                text: "",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      con_condiciones
        ? {
          margin: [0, 30, 0, 0],
          table: {
            widths: ["*", "*"],
            body: [
              [
                {
                  colSpan: 2,
                  margin: [0, 60, 0, 20],
                  fontSize: 18,
                  text: "\n\nTÉRMINOS Y CONDICIONES:",
                  bold: true,
                  alignment: "left",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "1.- Las bicicletas se recogerán y entregarán en el horario establecido que va desde las 08:00 horas a las 21:00 horas todos los días de la semana.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: [
                    "2.- La devolución de la/s bicicleta/ y material alquilado se llevará a cabo en el lugar del arrendamiento, el día ",
                    {
                      text: _captionFecha(modelReserva.fecha_final),
                      fontSize: 10,
                      bold: true,
                    },
                    " a la hora 21:00. El incumplimiento de la hora de entrega ocasionará un cargo adicional al cliente de 10 euros por hora de retraso. De no realizar la entrega en el día estipulado en el contrato, el cargo adicional ocasionado, será de 35 euros. Al no realizar la entrega, el arrendador podrá tomar posesión inmediata la bicicleta en el lugar donde se encuentre, sin tener derecho a reclamación alguna por parte del arrendatario.",
                  ],
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "3.- La franja horaria de alquiler queda comprendida: Día completo: 08:00 a 21:00 horas.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "4.- El material se devolverá completo y en el mismo estado en el que se le entregó al cliente. El coste por reparación o reposición de la bicicleta y/o del material correrá a cargo del cliente. El cliente deberá informar al arrendador, de los daños ocasionados en dicho material o del mal funcionamiento del mismo. El cliente esta obligado a tener buen cuidado y tomar todas las precauciones necesarias para proteger las bicicletas y el equipo alquilado de daños, perdida o robo. De producirse cualquiera de las mencionadas situaciones durante el periodo de alquiler, el cliente asumirá de manera inmediata la totalidad de los costes de reposición ocasionados a precio de tarifa o de mercado según el arrendador disponga o no de la pieza a reponer. Al final del periodo de alquiler el arrendador, determinará las condiciones de entrega del material alquilado y valorará dado el caso, las pérdidas o daños ocasionados. El cliente está obligado en todo momento a fijar correctamente con el candado y cadena de seguridad la/s bicicleta/s cuando no las tenga a la vista (pasar el candado por el cuadro, sillín y ruedas y atar la bicicleta aun poste fijado al suelo o bici parking).",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "5.- El arrendatario declara estar en perfectas condiciones de salud, ser capaz de manejar una bicicleta y poseer el control necesario del equipamiento alquilado.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: [
                    "6.- En este acto el arrendatario entrega al arrendador, una ",
                    {
                      text: "fianza de " + modelReserva.fianza + " euros",
                      fontSize: 10,
                      bold: true,
                    },
                    " que servirá para responder de los posibles daños causados a la bicicleta o el equipamiento alquilado, dicha fianza será reembolsada al finalizar el contrato. En caso de pérdida o robo de la bicicleta, el arrendador perderá todo el derecho a la fianza, debiendo comunicar de inmediato tal circunstancia. Además, deberá proceder a indemnizar al arrendatario por la cantidad estipulada según precio de mercado.",
                  ],
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "7.- El alquiler de bicicleta no incluye seguro de daños propios, por lo que el arrendatario es responsable de todos los daños de material o personales que pueda sufrir. El alquiler se realiza con la cobertura del correspondiente seguro de RC que cubre todos los daños causados por origen del alquiler a terceros, personas o bienes. Es responsabilidad del cliente y de su/s acompañante/s respetar las normas de tráfico españolas y conducir con cuidado y respetar a los peatones.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "8.- Los datos facilitados por el cliente, serán utilizados exclusivamente para la correcta prestación del servicio contratado, pudiendo solicitar, de acuerdo con la ley, su acceso, rectificación, cancelación u oposición mediante comunicación por cualquier medio al arrendador. Este contrato se rige por la ley española.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "9.- En caso de que el arrendador necesite asistencía en viaje sin que hubiese sido contratada con anterioridad, el coste será de 15€ hora, y 15€ de desplazamiento a la zona donde se encuentre el cliente.",
                },
                "",
              ],
              [
                {
                  colSpan: 2,
                  margin: [0, 5, 0, 0],
                  fontSize: 10,
                  text: "10.- En caso de que el arrendador decida devolver las bicicletas en fecha anterior a la finalizacion de este contrato, no tendrá derecho a la devolución alguna.",
                },
                "",
              ],
              [
                {
                  margin: [0, 40, 0, 0],
                  fontSize: 10,
                  bold: true,
                  text: "Firma del Arrendador",
                },
                {
                  margin: [0, 40, 0, 0],
                  fontSize: 10,
                  bold: true,
                  text: "Firma del Arrendatario - Contratante",
                },
              ],

              [
                {
                  width: "auto",
                  fit: [180, 100],
                  image: imagenFirma,
                  alignment: "left",
                },

                {
                  text: "",
                },
              ],
            ],
          },
          layout: "noBorders",
        }
        : "",
    ],
  };

  return docDefinition;
}


export async function reporteFactura(
  context,
  [
    modelReserva,
    presupuestoImagen7,
    imagenFirma,
    importe_s,
    importe_m,
    importe_l,
    importe_xl,
    campoFacturaFilas,
    campoFacturaClienteNombre,
    campoFacturaClienteDNI,
    campoFacturaClienteDomicilio,
    campoFacturaDescripcionAlquiler,
    campoFacturaDescripcionTransporte,
    campoFacturaPrecioAlquiler,
    campoFacturaPrecioTransporte,
    campoFacturaFecha,
    campoFacturaPrecioAlquilerMuscular,
    campoFacturaNumeroFactura,
    campoFacturaBaseImponible,
    campoFacturaIVA,
    campoFacturaTotal,
    campoFacturaCuentaBancaria1,
    campoFacturaBicCuenta1,
    campoFacturaCuentaBancaria2,
    campoFacturaBicCuenta2
  ]
) {
  const toText = (value) => (value === null || value === undefined ? "" : String(value));
  const parseAmount = (value) => {
    if (value === null || value === undefined || value === "") {
      return 0;
    }

    if (typeof value === "number") {
      return Number.isFinite(value) ? value : 0;
    }

    let normalized = String(value).trim().replace(/\s/g, "").replace(/€/g, "");
    if (normalized === "") {
      return 0;
    }

    const hasComma = normalized.includes(",");
    const hasDot = normalized.includes(".");

    if (hasComma && hasDot) {
      if (normalized.lastIndexOf(",") > normalized.lastIndexOf(".")) {
        normalized = normalized.replace(/\./g, "").replace(",", ".");
      } else {
        normalized = normalized.replace(/,/g, "");
      }
    } else if (hasComma) {
      normalized = normalized.replace(/\./g, "").replace(",", ".");
    }

    const parsed = parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  };
  const formatAmount = (value) => {
    const text = toText(value).trim();
    if (text === "") {
      return "";
    }
    if (!/[0-9]/.test(text)) {
      return text;
    }

    const fixed = parseAmount(text).toFixed(2);
    const parts = fixed.split(".");
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    const decimalPart = parts[1];
    const formatted = integerPart + "," + decimalPart;

    return formatted + " €";
  };

  const fechaFactura = campoFacturaFecha || modelReserva.fecha_inicial || new Date().toISOString().substring(0, 10);
  const clienteNombreFactura = campoFacturaClienteNombre || (modelReserva.cliente ? modelReserva.cliente.nombre : "") || "";
  const clienteDNIFactura = campoFacturaClienteDNI || (modelReserva.cliente ? modelReserva.cliente.dni : "") || "";
  const clienteDomicilioFactura = campoFacturaClienteDomicilio || (modelReserva.cliente ? modelReserva.cliente.domicilio : "") || "";

  const filasFactura = Array.isArray(campoFacturaFilas)
    ? campoFacturaFilas.slice(0, 5).map((fila) => ({
      descripcion: toText(fila && fila.descripcion),
      unidades: toText(fila && fila.unidades),
      precio: toText(fila && fila.precio),
      importe: toText(fila && fila.importe),
    }))
    : [];

  while (filasFactura.length < 5) {
    filasFactura.push({
      descripcion: "",
      unidades: "",
      precio: "",
      importe: "",
    });
  }

  const filasDetalleBody = filasFactura.map((fila) => [
    {
      fontSize: 10,
      text: fila.descripcion,
    },
    {
      fontSize: 10,
      text: fila.unidades,
      alignment: "center",
    },
    {
      fontSize: 10,
      text: formatAmount(fila.precio),
      alignment: "center",
    },
    {
      fontSize: 10,
      text: formatAmount(fila.importe),
      alignment: "center",
    },
  ]);

  const baseImponibleCalculado = filasFactura.reduce(
    (sum, fila) => sum + parseAmount(fila.importe),
    0
  );
  const baseImponibleNumero =
    toText(campoFacturaBaseImponible).trim() !== ""
      ? parseAmount(campoFacturaBaseImponible)
      : baseImponibleCalculado;
  const baseImponible = formatAmount(baseImponibleNumero);

  let ivaCalculado = 0;
  if (Number(modelReserva.sin_iva) == 0) {
    ivaCalculado = parseFloat((baseImponibleNumero * 0.21).toFixed(2));
  }
  const ivaNumero =
    toText(campoFacturaIVA).trim() !== ""
      ? parseAmount(campoFacturaIVA)
      : ivaCalculado;
  const iva = formatAmount(ivaNumero);

  const totalCalculado = parseFloat((baseImponibleNumero + ivaNumero).toFixed(2));
  const totalNumero =
    toText(campoFacturaTotal).trim() !== ""
      ? parseAmount(campoFacturaTotal)
      : totalCalculado;
  const total = formatAmount(totalNumero);

  const descuentoNumero = parseAmount(modelReserva.descuento);
  const mostrarDescuento = descuentoNumero > 0;
  const totalFinal = formatAmount(parseFloat((totalNumero - descuentoNumero).toFixed(2)));
  const numeroFactura = toText(campoFacturaNumeroFactura).trim() !== ""
    ? toText(campoFacturaNumeroFactura).trim()
    : (modelReserva.factura != null ? String(modelReserva.factura) : "");
  const cuenta1 = toText(campoFacturaCuentaBancaria1).trim() !== ""
    ? toText(campoFacturaCuentaBancaria1).trim()
    : "ABANCA: ES83 2080 0306 5130 4002 5574";
  const bic1 = toText(campoFacturaBicCuenta1).trim() !== ""
    ? toText(campoFacturaBicCuenta1).trim()
    : "CAGLESMMXXX";
  const cuenta2 = toText(campoFacturaCuentaBancaria2).trim() !== ""
    ? toText(campoFacturaCuentaBancaria2).trim()
    : "CAIXABANK: ES82 2100 4775 2502 0038 4614";
  const bic2 = toText(campoFacturaBicCuenta2).trim() !== ""
    ? toText(campoFacturaBicCuenta2).trim()
    : "CAIXESBBXXX";

  var docDefinition = {
    info: {
      title: fechaFactura.substring(0, 10).replaceAll("-", "").replaceAll("/", "") +
        "_" +
        modelReserva.id.toString() +
        "_" +
        modelReserva.cliente.nombre.replaceAll(" ", "") +
        "_Factura.pdf"
    },
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 20],

    content: [
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ["*", 200],
          body: [
            [
              {
                text: [
                  {
                    text: "DAVID FRAGÍO AGRA\n\n",
                    fontSize: 18,
                    bold: true,
                    color: "#0070BD",
                  },
                  "44831130-J\n",
                  "Lugar de Sabaxáns nº 48\n",
                  "15280 Brión\n",
                  "A CORUÑA\n",
                  "Tfno: 699 331 965\n\n",
                  {
                    text: "info@ebikecompostela.es\n",
                    fontSize: 10,
                    color: "#0070BD",
                  },
                  {
                    text: "www.ebikecompostela.es\n",
                    fontSize: 10,
                    color: "#0070BD",
                  },
                ],
              },

              {
                width: "auto",
                fit: [80, 100],
                image: presupuestoImagen7,
                alignment: "center",
              },
            ],
            [
              "",
              {
                alignment: "center",
                text: [
                  clienteNombreFactura + "\n",
                  (clienteDNIFactura != null
                    ? clienteDNIFactura
                    : "") + "\n",
                  (clienteDomicilioFactura != null
                    ? clienteDomicilioFactura
                    : "") + "\n",
                ],
              },
            ],
            [
              {
                alignment: "left",
                text: [
                  "FECHA:        " +
                  _captionFecha(fechaFactura) +
                  "\n\n",
                  "Nº FACTURA:   " +
                  numeroFactura +
                  "\n",
                ],
              },
              "",
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 10, 0, 0],
        table: {
          widths: ["*", 80, 80, 80],
          body: [
            [
              {
                fontSize: 12,
                text: " Descripción",
                fillColor: "#DCEBF7",
              },
              {
                fontSize: 12,
                text: "Unidades",
                fillColor: "#DCEBF7",
                alignment: "center",
              },
              {
                fontSize: 12,
                text: "Precio",
                fillColor: "#DCEBF7",
                alignment: "center",
              },
              {
                fontSize: 12,
                text: "IMPORTE",
                fillColor: "#DCEBF7",
                alignment: "center",
              },
            ],
            ...filasDetalleBody,

            [
              {
                margin: [0, 40, 0, 0],
                text: "",
              },
              {
                margin: [0, 40, 0, 0],
                text: "",
              },
              {
                margin: [0, 40, 0, 0],
                text: "",
              },
              {
                margin: [0, 40, 0, 0],
                text: "",
              },
            ],

            [
              {
                text: "",
                fillColor: "#DCEBF7",
              },
              {
                text: "",
                fillColor: "#DCEBF7",
              },
              {
                text: "",
                fillColor: "#DCEBF7",
              },
              {
                text: "",
                fillColor: "#DCEBF7",
              },
            ],
            ["", "", "", ""],

            [
              "",
              {
                colSpan: 2,
                text: "BASE IMPONIBLE:",
                alignment: "right",
              },
              "",
              {
                text: baseImponible,
                fillColor: "#DCEBF7",
                alignment: "center",
              },
            ],
            ["", "", "", ""],
            [
              "",
              {
                colSpan: 2,
                text: "IVA (21%)",
                alignment: "right",
              },
              "",
              {
                text: iva,
                fillColor: "#DCEBF7",
                alignment: "center",
              },
            ],
            ["", "", "", ""],
            [
              "",
              {
                colSpan: 2,
                text: "TOTAL:",
                alignment: "right",
                bold: true,
              },
              "",
              {
                text: total,
                fillColor: "#DCEBF7",
                alignment: "center",
                bold: true,
              },
            ],
            ["", "", "", ""],
            mostrarDescuento ?
              [
                "",
                {
                  colSpan: 2,
                  text: "DESCUENTO:",
                  alignment: "right",

                },
                "",
                {
                  text: formatAmount(descuentoNumero),
                  fillColor: "#DCEBF7",
                  alignment: "center",

                },
              ] : ["", "", "", ""],
            ["", "", "", ""],
            mostrarDescuento ?
              [
                "",
                {
                  colSpan: 2,
                  text: "TOTAL FINAL:",
                  alignment: "right",
                  bold: true,
                },
                "",
                {
                  text: totalFinal,
                  fillColor: "#DCEBF7",
                  alignment: "center",
                  bold: true,
                },
              ] : ["", "", "", ""],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 40, 0, 0],
        table: {
          widths: [100, 20, "*"],
          body: [
            [
              {
                border: [false, false, false, true],
                text: "FORMA DE PAGO:",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 9,
                text: cuenta1 + "    BIC: " + bic1,
              },
            ],
            [
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [false, false, false, false],
                fontSize: 9,
                text: cuenta2 + "    BIC: " + bic2,
              },
            ],
          ],
        },
      },

      {
        margin: [0, 40, 0, 0],
        table: {
          widths: ["*"],
          heights: [1, 80, 1],
          body: [
            [
              {
                text: "",
                fillColor: "#CCCCCC",
              },
            ],
            [
              {
                fontSize: 6,
                text:
                  "Responsable del tratamiento: David Fragío Agra, CIF: 44831130- J Dir. Postal: SABAXANS Nº 47 - 15280-BRIÓN- A CORUÑA. Teléfono: 699331965 Correo electrónico: info@ebikecompostela.es" +
                  "En nombre de la empresa tratamos la información que nos facilita con el fin de prestarle el servicio solicitado y realizar la facturación del mismo, la cual se conservará mientras se mantenga" +
                  "la relación comercial o durante el tiempo necesario para cumplir con las obligaciones legales y atender las posibles responsabilidades que pudieran derivar del cumplimiento de la" +
                  "finalidad para la que los datos fueron recabados, y no se cederán a terceros salvo en los casos en que exista una obligación legal, ni se elaborará ningún tipo de “perfil”. Podrá ejercer los" +
                  "derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, portabilidad de datos y a no ser objeto de decisiones individualizadas, automatizadas, en relación con" +
                  "los datos objeto del tratamiento, ante esta entidad, vía e-mail, personalmente o mediante correo postal, adjuntando copia de su DNI o documento equivalente. En caso de que no haya" +
                  "obtenido satisfacción en el ejercicio de sus derechos, puede presentar una reclamación ante la Autoridad de Control en materia Protección de Datos competente, siendo ésta la AGPD y" +
                  "cuyos datos de contacto están accesibles en https://sedeagpd.gob.es/sede-electronica-web/vistas/formNuevaReclamacion/reclamacion.jsf.",
              },
            ],
            [
              {
                text: "",
                fillColor: "#CCCCCC",
              },
            ],
          ],
        },
        layout: "noBorders",
      },
    ],
  };

  return docDefinition;
}



export async function reporteContrato(
  context,
  [
    modelReserva,
    presupuestoImagen7,
    imagenFirma,
    campoContratoHoraInicio,
    campoContratoHoraFin,
    campoContratoCasco,
    campoContratoCandado,
    campoContratoCargador,
    campoContratoKitPinchazos,
    campoContratoAlforjas,
    campoContratoBateriaExtra,
    campoContratoObservaciones,
  ]
) {
  var docDefinition = {
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 20],

    content: [
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ["*", 80],
          body: [
            [
              {
                table: {
                  widths: ["*"],
                  body: [
                    [
                      {
                        fontSize: 18,
                        text: "Contrato de Alquiler de Bicicletas",
                        bold: true,
                        alignment: "left",
                      },
                    ],
                    [
                      {
                        text: "www.ebikecompostela.es                info@ebikecompostela.es",
                        alignment: "left",
                        color: "#1E88E5",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },

              {
                width: "auto",
                fit: [80, 100],
                image: presupuestoImagen7,
                alignment: "left",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [80, 100, "*"],
          body: [
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Fecha: ",
                bold: true,
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: _captionFecha(modelReserva.fecha_inicial),
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [140, 40, "*"],
          body: [
            [
              {
                colSpan: 3,
                border: [false, false, false, true],
                fontSize: 10,
                bold: true,
                text: "Datos Arrendador",
              },
              "",
              "",
            ],
            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "DNI",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Nombre y Apellidos",
              },
            ],
            [
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: "44831130-J",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: "David Fragio Agra",
              },
            ],

            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Domicilio",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
            ],

            [
              {
                colSpan: 3,
                border: [true, true, true, true],
                fontSize: 10,
                text: "Lugar de Sabaxans nº 48 - Brión",
              },
              "",
              "",
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Teléfono",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "E-mail",
              },
            ],
            [
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: "699 331 965",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: "info@ebikecompostela.es",
                color: "#1E88E5",
              },
            ],

            [
              {
                margin: [0, 20, 0, 0],
                colSpan: 3,
                border: [false, false, false, true],
                fontSize: 10,
                bold: true,
                text: "Datos Arrendatario",
              },
              "",
              "",
            ],

            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "DNI",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Nombre y Apellidos",
              },
            ],
            [
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.dni,
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.nombre,
              },
            ],

            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Domicilio",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
            ],

            [
              {
                colSpan: 3,
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.domicilio,
              },
              "",
              "",
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Teléfono",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "E-mail",
              },
            ],
            [
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.telefono,
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.email,
                color: "#1E88E5",
              },
            ],
          ],
        },
      },

      {
        margin: [0, 40, 0, 0],
        table: {
          widths: [60, 60, 20, 60, 60, 20, "*", "*"],
          body: [
            [
              {
                colSpan: 8,
                border: [false, false, false, true],
                fontSize: 10,
                bold: true,
                text: "Objeto del Contrato",
              },
              "",
              "",
              "",
              "",
              "",
              "",
              "",
            ],

            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Casco",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: campoContratoCasco,
                fontSize: 10,
                alignment: "center",
              },
            ],
            [
              {
                colSpan: 3,
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Cantidad de Bicicletas",
              },
              "",
              "",
              {
                colSpan: 5,
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Número",
              },
              "",
              "",
              "",
              "",
            ],

            [
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cant_bicis,
                alignment: "center",
              },
              "",
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                fontSize: 10,
                text: _captionBicisNumero(modelReserva),
              },
              "",
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Candado",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                fontSize: 10,
                text: campoContratoCandado,
                alignment: "center",
              },
            ],
            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],

            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Hora Inicio",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: campoContratoHoraInicio,
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                text: "",
              },

              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Hora Fin",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: campoContratoHoraFin,
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Cargador",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                fontSize: 10,
                text: campoContratoCargador,
                alignment: "center",
              },
            ],

            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Kit Pinchazos",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: campoContratoKitPinchazos,
                fontSize: 10,
                alignment: "center",
              },
            ],

            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],

            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "Importe Alquiler",
                fontSize: 10,
              },
              "",
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Alforjas",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: campoContratoAlforjas,
                fontSize: 10,
                alignment: "center",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: modelReserva.total + " €",
                fontSize: 10,
                alignment: "center",
              },
              "",
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Bateria Extra",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: campoContratoBateriaExtra,
                fontSize: 10,
                alignment: "center",
              },
            ],
          ],
        },
      },

      {
        margin: [0, 30, 0, 0],
        table: {
          widths: ["*"],
          heights: [10, 80],
          body: [
            [
              {
                border: [false, false, false, true],
                fontSize: 10,
                bold: true,
                text: "Observaciones",
              },
            ],
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: campoContratoObservaciones,
              },
            ],
          ],
        },
      },

      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                colSpan: 2,
                margin: [0, 20, 0, 10],
                fontSize: 16,
                text: "\n\nTÉRMINOS Y CONDICIONES ESPECÍFICAS DEL CONTRATO",
                bold: true,
                alignment: "left",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: [
                  "1.- El presente contrato de arrendamiento tendrá duración de ",
                  {
                    text: modelReserva.cant_dias,
                    fontSize: 10,
                    bold: true,
                  },
                  " días.",
                ],
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "2.- Las bicicletas se recogerán y entregarán en el horario establecido que va desde las 08:00 horas a las 21:00 horas todos los días de la semana.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                fontSize: 10,
                text: [
                  "La devolución de la/s bicicleta/ y material alquilado se llevará a cabo en el lugar del arrendamiento, en el día ",
                  {
                    text: _captionFecha(modelReserva.fecha_final),
                    fontSize: 10,
                    bold: true,
                  },
                  " y a la hora: ",
                  {
                    text: "21:00",
                    fontSize: 10,
                    bold: true,
                  },
                  ". El incumplimiento de la hora de entrega ocasionará un cargo adicional al cliente de 10 euros por hora de retraso. De no realizar la entrega en el día estipulado en el contrato, el cargo adicional ocasionado, será de 45 euros. Al no realizar la entrega, el arrendador podrá tomar posesión inmediata la bicicleta en el lugar donde se encuentre, sin tener derecho a reclamación alguna por parte del arrendatario.",
                ],
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "3.- La franja horaria de alquiler queda comprendida: Día completo: 08:00 a 21:00 horas.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "4.- El material se devolverá completo y en el mismo estado en el que se le entregó al cliente. El coste por reparación o reposición de la bicicleta y/o del material correrá a cargo del cliente. El cliente deberá informar al arrendador, de los daños ocasionados en dicho material o del mal funcionamiento del mismo. El cliente esta obligado a tener buen cuidado y tomar todas las precauciones necesarias para proteger las bicicletas y el equipo alquilado de daños, perdida o robo. De producirse cualquiera de las mencionadas situaciones durante el periodo de alquiler, el cliente asumirá de manera inmediata la totalidad de los costes de reposición ocasionados a precio de tarifa o de mercado según el arrendador disponga o no de la pieza a reponer. Al final del periodo de alquiler el arrendador, determinará las condiciones de entrega del material alquilado y valorará dado el caso, las pérdidas o daños ocasionados. El cliente está obligado en todo momento a fijar correctamente con el candado y cadena de seguridad la/s bicicleta/s cuando no las tenga a la vista (pasar el candado por el cuadro, sillín y ruedas y atar la bicicleta aun poste fijado al suelo o bici parking).",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "5.- El arrendatario declara estar en perfectas condiciones de salud, ser capaz de manejar una bicicleta y poseer el control necesario del equipamiento alquilado.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: [
                  "6.- En este acto el arrendatario entrega al arrendador, una ",
                  {
                    text: "fianza de " + modelReserva.fianza + " euros",
                    fontSize: 10,
                    bold: true,
                  },
                  " mediante tarjeta de crédito que servirá para responder de los posibles daños causados a la bicicleta o el equipamiento alquilado, dicha fianza será reembolsada al finalizar el contrato. En caso de pérdida o robo de la bicicleta, el arrendador perderá todo el derecho a la fianza, debiendo comunicar de inmediato tal circunstancia. Además, deberá proceder a indemnizar al arrendatario por la cantidad estipulada según precio de mercado.",
                ],
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "7.- El alquiler de bicicleta no incluye seguro de daños propios, por lo que el arrendatario es responsable de todos los daños de material o personales que pueda sufrir. El alquiler se realiza con la cobertura del correspondiente seguro de RC que cubre todos los daños causados por origen del alquiler a terceros, personas o bienes. Es responsabilidad del cliente y de su/s acompañante/s respetar las normas de tráfico españolas y conducir con cuidado y respetar a los peatones.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "8.- Los datos facilitados por el cliente, serán utilizados exclusivamente para la correcta prestación del servicio contratado, pudiendo solicitar, de acuerdo con la ley, su acceso, rectificación, cancelación u oposición mediante comunicación por cualquier medio al arrendador. Este contrato se rige por la ley española.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "9.- En caso de que el arrendador necesite asistencía en viaje sin que hubiese sido contratada con anterioridad, el coste será de 15€ hora, y 15€ de desplazamiento a la zona donde se encuentre el cliente.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "10.- En caso de que el arrendador decida devolver las bicicletas en fecha anterior a la finalizacion de este contrato, no tendrá derecho a la devolución alguna.",
              },
              "",
            ],
            [
              {
                margin: [0, 40, 0, 0],
                fontSize: 10,
                bold: true,
                text: "Firma del Arrendador",
              },
              {
                margin: [0, 40, 0, 0],
                fontSize: 10,
                bold: true,
                text: "Firma del Arrendatario - Contratante",
              },
            ],

            [
              {
                width: "auto",
                fit: [180, 100],
                image: imagenFirma,
                alignment: "left",
              },

              {
                text: "",
              },
            ],
          ],
        },
        layout: "noBorders",
      },
    ],
  };

  return docDefinition;
}

export async function reporteContratoIngles(
  context,
  [
    modelReserva,
    presupuestoImagen7,
    imagenFirma,
    campoContratoHoraInicio,
    campoContratoHoraFin,
    campoContratoCasco,
    campoContratoCandado,
    campoContratoCargador,
    campoContratoKitPinchazos,
    campoContratoAlforjas,
    campoContratoBateriaExtra,
    campoContratoObservaciones,
  ]
) {
  var docDefinition = {
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 20],

    content: [
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ["*", 80],
          body: [
            [
              {
                table: {
                  widths: ["*"],
                  body: [
                    [
                      {
                        fontSize: 18,
                        text: "Bicycles Lease",
                        bold: true,
                        alignment: "left",
                      },
                    ],
                    [
                      {
                        text: "www.ebikecompostela.es                info@ebikecompostela.es",
                        alignment: "left",
                        color: "#1E88E5",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },

              {
                width: "auto",
                fit: [80, 100],
                image: presupuestoImagen7,
                alignment: "left",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [80, 100, "*"],
          body: [
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Date: ",
                bold: true,
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: _captionFecha(modelReserva.fecha_inicial),
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [140, 40, "*"],
          body: [
            [
              {
                colSpan: 3,
                border: [false, false, false, true],
                fontSize: 10,
                bold: true,
                text: "Lessor’s Information",
              },
              "",
              "",
            ],
            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "DNI",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Name and Surname",
              },
            ],
            [
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: "44831130-J",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: "David Fragio Agra",
              },
            ],

            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Address",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
            ],

            [
              {
                colSpan: 3,
                border: [true, true, true, true],
                fontSize: 10,
                text: "Lugar de Sabaxans nº 48 - Brión",
              },
              "",
              "",
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Telephone",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "E-mail",
              },
            ],
            [
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: "699 331 965",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: "info@ebikecompostela.es",
                color: "#1E88E5",
              },
            ],

            [
              {
                margin: [0, 20, 0, 0],
                colSpan: 3,
                border: [false, false, false, true],
                fontSize: 10,
                bold: true,
                text: "Lessee’s Information",
              },
              "",
              "",
            ],

            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "DNI",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Name and Surname",
              },
            ],
            [
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.dni,
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.nombre,
              },
            ],

            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Address",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
            ],

            [
              {
                colSpan: 3,
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.domicilio,
              },
              "",
              "",
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Telephone",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "E-mail",
              },
            ],
            [
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.telefono,
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.email,
                color: "#1E88E5",
              },
            ],
          ],
        },
      },

      {
        margin: [0, 40, 0, 0],
        table: {
          widths: [60, 60, 20, 60, 60, 20, "*", "*"],
          body: [
            [
              {
                colSpan: 8,
                border: [false, false, false, true],
                fontSize: 10,
                bold: true,
                text: "Aim of the Contract",
              },
              "",
              "",
              "",
              "",
              "",
              "",
              "",
            ],

            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Helmet",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: campoContratoCasco,
                fontSize: 10,
                alignment: "center",
              },
            ],
            [
              {
                colSpan: 3,
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Amount of bicycles",
              },
              "",
              "",
              {
                colSpan: 5,
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Number",
              },
              "",
              "",
              "",
              "",
            ],

            [
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cant_bicis,
                alignment: "center",
              },
              "",
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                fontSize: 10,
                text: _captionBicisNumero(modelReserva),
              },
              "",
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Padlock",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                fontSize: 10,
                text: campoContratoCandado,
                alignment: "center",
              },
            ],
            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],

            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "From",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: campoContratoHoraInicio,
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                text: "",
              },

              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "To",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: campoContratoHoraFin,
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Charger",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                fontSize: 10,
                text: campoContratoCargador,
                alignment: "center",
              },
            ],

            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Puncture kit",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: campoContratoKitPinchazos,
                fontSize: 10,
                alignment: "center",
              },
            ],

            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],

            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "Rent Cost",
                fontSize: 10,
              },
              "",
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Saddlebag",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: campoContratoAlforjas,
                fontSize: 10,
                alignment: "center",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: modelReserva.total + " €",
                fontSize: 10,
                alignment: "center",
              },
              "",
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Handlebar bags",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: campoContratoBateriaExtra,
                fontSize: 10,
                alignment: "center",
              },
            ],
          ],
        },
      },

      {
        margin: [0, 30, 0, 0],
        table: {
          widths: ["*"],
          heights: [10, 80],
          body: [
            [
              {
                border: [false, false, false, true],
                fontSize: 10,
                bold: true,
                text: "Observations",
              },
            ],
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: campoContratoObservaciones,
              },
            ],
          ],
        },
      },

      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                colSpan: 2,
                margin: [0, 20, 0, 10],
                fontSize: 16,
                text: "\n\nSPECIFIC TERMS AND CONDITIONS OF THE CONTRACT",
                bold: true,
                alignment: "left",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: [
                  "1.- The following lease will have a duration of ",
                  {
                    text: modelReserva.cant_dias + " days",
                    fontSize: 10,
                    bold: true,
                  },
                ],
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "2.- Bicycles will be picked up and brought back between the established schedule which goes from 8:00 to 21:00 every day of the week.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                fontSize: 10,
                text: [
                  "The return of bicycles and any other rented material will take place at the place of rental,  On: ",
                  {
                    text: _captionFecha(modelReserva.fecha_final),
                    fontSize: 10,
                    bold: true,
                  },
                  " at: ",
                  {
                    text: "21:00",
                    fontSize: 10,
                    bold: true,
                  },
                  ". Failure to comply with the time of return the customer will have to pay an extra of 10 euros per hour. If the return were to not be done the stipulated day, additional charge would be of 45 euros. In said case, the lessor shall take immediate possession of the bicycle wherever it may be, without any complaint from the lessee.",
                ],
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "3.- The rental period is comprised of: Whole day: 8:00 to 21:00",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "4.- The rented material shall be returned in its entirety in the same state that the client received it. Cost for repair or replenishment of the bicycle and/or any other rented material will be client’s responsibility. They shall inform the lessor of caused damage or malfunction. They are obligated to maintain the rented material in good condition and take all necessary precaution to protect it from harm, loss and theft. If any of said situations were to happen during the lease period, the client will immediately assume the entirety of the replacement costs at tariff or market price, depending on whether or not the lessor has the part to be replaced. At the end of the lease period the lessor will determine return condition and they will assess, given the circumstances, the loss or damaged caused. The client will be obligated to verify their padlock and security chain are properly placed (pass the lock through the frame, saddle and wheels and tie the bike to a post fixed to the ground or bike parking).",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "5.- The lessee declares they are in perfect health condition, are capable of riding a bicycle and poses necessary control over the rented material.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: [
                  "6.- In this act, the lessee submits the lessor a ",
                  {
                    text: modelReserva.fianza + " euros",
                    fontSize: 10,
                    bold: true,
                  },
                  " bail trough credit card which will be used as collateral for any possible damage and shall be refunded at the end of the lease. In case of loss or theft of the bicycle, the lessee will lose all right to the bail, having to communicate said circumstance right away. Moreover, they must compensate the lessor for the stipulated amount accorded to market price.",
                ],
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "7.- This lease does not include own damage insurance, so the lessee is responsible for all material or personal damage they may suffer. The rental includes the corresponding liability insurance that covers all damages caused by the rental to third parties, people or goods. The client and their companions must obey Spanish traffic regulations, drive safely and respect pedestrians.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "8.- The data provided by the customer will be exclusively used to guarantee the correct service provision, being always able to request access, rectification, cancellation or objection by communicating with the lessor, according to the law.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "9.- In the event that the lessee needs travel assistance without having contracted it beforehand, the cost will be of 15€ per hour and 15€ to go where the client is located.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "10.- In the event that the lessee decides to return the rented equipment on a date before the end of the contract expires, they will not be entitled to any refund.",
              },
              "",
            ],
            [
              {
                margin: [0, 40, 0, 0],
                fontSize: 10,
                bold: true,
                text: "Lessor’s Signature",
              },
              {
                margin: [0, 40, 0, 0],
                fontSize: 10,
                bold: true,
                text: "Lessee’s Signature",
              },
            ],

            [
              {
                width: "auto",
                fit: [180, 100],
                image: imagenFirma,
                alignment: "left",
              },

              {
                text: "",
              },
            ],
          ],
        },
        layout: "noBorders",
      },
    ],
  };

  return docDefinition;
}

export async function reporteContratoPortuges(
  context,
  [
    modelReserva,
    presupuestoImagen7,
    imagenFirma,
    campoContratoHoraInicio,
    campoContratoHoraFin,
    campoContratoCasco,
    campoContratoCandado,
    campoContratoCargador,
    campoContratoKitPinchazos,
    campoContratoAlforjas,
    campoContratoBateriaExtra,
    campoContratoObservaciones,
  ]
) {
  var docDefinition = {
    pageOrientation: "portrait",
    pageMargins: [30, 15, 40, 20],

    content: [
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ["*", 80],
          body: [
            [
              {
                table: {
                  widths: ["*"],
                  body: [
                    [
                      {
                        fontSize: 18,
                        text: "Contrato de Aluguer de Bicicletas",
                        bold: true,
                        alignment: "left",
                      },
                    ],
                    [
                      {
                        text: "www.ebikecompostela.es                info@ebikecompostela.es",
                        alignment: "left",
                        color: "#1E88E5",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },

              {
                width: "auto",
                fit: [80, 100],
                image: presupuestoImagen7,
                alignment: "left",
              },
            ],
          ],
        },
        layout: "noBorders",
      },

      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [80, 100, "*"],
          body: [
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Data: ",
                bold: true,
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: _captionFecha(modelReserva.fecha_inicial),
              },
              {
                border: [false, false, false, false],
                text: "",
              },
            ],
          ],
        },
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          widths: [140, 40, "*"],
          body: [
            [
              {
                colSpan: 3,
                border: [false, false, false, true],
                fontSize: 10,
                bold: true,
                text: "Dados do Arrendador",
              },
              "",
              "",
            ],
            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "DNI",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Nomes e sobrenomes",
              },
            ],
            [
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: "44831130-J",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: "David Fragio Agra",
              },
            ],

            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Lar",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
            ],

            [
              {
                colSpan: 3,
                border: [true, true, true, true],
                fontSize: 10,
                text: "Lugar de Sabaxans nº 48 - Brión",
              },
              "",
              "",
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Telefone",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "E-mail",
              },
            ],
            [
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: "699 331 965",
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: "info@ebikecompostela.es",
                color: "#1E88E5",
              },
            ],

            [
              {
                margin: [0, 20, 0, 0],
                colSpan: 3,
                border: [false, false, false, true],
                fontSize: 10,
                bold: true,
                text: "Informações do inquilino",
              },
              "",
              "",
            ],

            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "DNI",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Nomes e sobrenomes",
              },
            ],
            [
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.dni,
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.nombre,
              },
            ],

            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Lar",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
            ],

            [
              {
                colSpan: 3,
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.domicilio,
              },
              "",
              "",
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Telefone",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "E-mail",
              },
            ],
            [
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.telefono,
              },
              {
                border: [false, false, false, false],
                text: "",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cliente.email,
                color: "#1E88E5",
              },
            ],
          ],
        },
      },

      {
        margin: [0, 40, 0, 0],
        table: {
          widths: [60, 60, 20, 60, 60, 20, "*", "*"],
          body: [
            [
              {
                colSpan: 8,
                border: [false, false, false, true],
                fontSize: 10,
                bold: true,
                text: "Objeto do Contrato",
              },
              "",
              "",
              "",
              "",
              "",
              "",
              "",
            ],

            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Capacete",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: campoContratoCasco,
                fontSize: 10,
                alignment: "center",
              },
            ],
            [
              {
                colSpan: 3,
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Número de bicicletas",
              },
              "",
              "",
              {
                colSpan: 5,
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Número",
              },
              "",
              "",
              "",
              "",
            ],

            [
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                fontSize: 10,
                text: modelReserva.cant_bicis,
                alignment: "center",
              },
              "",
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                fontSize: 10,
                text: _captionBicisNumero(modelReserva),
              },
              "",
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Cadeado",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                fontSize: 10,
                text: campoContratoCandado,
                alignment: "center",
              },
            ],
            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],

            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Hora Inicio",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: campoContratoHoraInicio,
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                text: "",
              },

              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "Fin tempo",
              },
              {
                border: [true, true, true, true],
                fontSize: 10,
                text: campoContratoHoraFin,
                alignment: "center",
              },
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Carregador",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                fontSize: 10,
                text: campoContratoCargador,
                alignment: "center",
              },
            ],

            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Kit de punção",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: campoContratoKitPinchazos,
                fontSize: 10,
                alignment: "center",
              },
            ],

            [
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 10, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],

            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "Valor do Aluguel",
                fontSize: 10,
              },
              "",
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Alforjes",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: campoContratoAlforjas,
                fontSize: 10,
                alignment: "center",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: modelReserva.total + " €",
                fontSize: 10,
                alignment: "center",
              },
              "",
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
            ],
            [
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                text: "",
              },
              {
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
                fontSize: 10,
                text: "Bateria Extra",
              },
              {
                margin: [0, 0, 0, 0],
                border: [true, true, true, true],
                text: campoContratoBateriaExtra,
                fontSize: 10,
                alignment: "center",
              },
            ],
          ],
        },
      },

      {
        margin: [0, 30, 0, 0],
        table: {
          widths: ["*"],
          heights: [10, 80],
          body: [
            [
              {
                border: [false, false, false, true],
                fontSize: 10,
                bold: true,
                text: "Observações",
              },
            ],
            [
              {
                border: [false, false, false, false],
                fontSize: 10,
                text: campoContratoObservaciones,
              },
            ],
          ],
        },
      },

      {
        margin: [0, 20, 0, 0],
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                colSpan: 2,
                margin: [0, 20, 0, 10],
                fontSize: 16,
                text: "\n\nTERMOS E CONDIÇÕES ESPECÍFICAS DO CONTRATO",
                bold: true,
                alignment: "left",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: [
                  "1.- Este contrato de arrendamento terá uma duração de ",
                  {
                    text: modelReserva.cant_dias,
                    fontSize: 10,
                    bold: true,
                  },
                  " dias.",
                ],
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "2.- As bicicletas serão recolhidas e entregues no horário estabelecido, que funciona das 8h00 às 21h00 todos os dias da semana.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 0, 0, 0],
                fontSize: 10,
                text: [
                  "A devolução da(s) bicicleta(s) e equipamentos alugados será efetuada no local de aluguer, no día ",
                  {
                    text: _captionFecha(modelReserva.fecha_final),
                    fontSize: 10,
                    bold: true,
                  },
                  " e na época: ",
                  {
                    text: "21:00",
                    fontSize: 10,
                    bold: true,
                  },
                  ". O não cumprimento do horário de a entrega acarretará um custo adicional ao cliente de 10 euros por hora de atraso. Se você não executar entrega no dia estipulado no contrato, o custo adicional incorrido será de 45 euros. Por não efectuar a entrega, o locador poderá tomar posse imediata da bicicleta no local onde esta se encontre encontrado, sem ter direito a qualquer reclamação por parte do locatário.",
                ],
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "3.- O horário de locação está incluído: Dia inteiro: 08h00 às 21h00.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "4.- O material será devolvido completo e nas mesmas condições em que foi entregue ao cliente. Os custos de reparação ou substituição da bicicleta e/ou material serão suportados pelo cliente. O cliente deverá informar o locador de qualquer dano causado ao referido material ou do seu mau funcionamento. O cliente obriga-se a ter bons cuidados e tomar todas as precauções necessárias para proteger as bicicletas e equipamentos alugados contra danos, perdas ou roubos. Se ocorrer alguma das situações acima mencionadas durante o período de aluguer, o cliente assumirá imediatamente todos os custos de substituição incorridos à taxa ou preço de mercado, dependendo se o locador tem ou não a peça a substituir. No final do período de aluguer, o locador determinará as condições de entrega do material alugado e avaliará, se for o caso, eventuais perdas ou danos causados. O cliente obriga-se sempre a fixar corretamente a(s) bicicleta(s) com o cadeado e a corrente de segurança quando estes não estiverem visíveis (passar o cadeado pelo quadro, selim e rodas e amarrar a bicicleta a um poste fixado ao solo). estacionamento de bicicletas).",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "5.- O locatário declara estar em perfeitas condições de saúde, saber manejar a bicicleta e ter o controle necessário do equipamento alugado.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: [
                  "6.- Neste acto o locatário entrega ao locador uma ",
                  {
                    text: "caução de " + modelReserva.fianza + " euros",
                    fontSize: 10,
                    bold: true,
                  },
                  " por cartão de crédito que servirá para responder por possíveis danos causados ​​à bicicleta ou ao equipamento alugado, caução que será devolvida no final do contrato. Em caso de perda ou roubo da bicicleta, o locador perderá todo o direito à caução, devendo comunicar imediatamente tal circunstância. Além disso, deverá proceder à compensação do inquilino pelo valor estipulado de acordo com o preço de mercado.",
                ],
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "7.- O aluguer da bicicleta não inclui seguro contra danos, pelo que o locatário é responsável por todos os danos materiais ou pessoais que possa sofrer. O aluguer é efectuado com a cobertura do correspondente seguro de responsabilidade civil que cobre todos os danos causados ​​pelo aluguer a terceiros, pessoas ou bens. É da responsabilidade do cliente e do(s) seu(s) acompanhante(s) respeitar as regras de trânsito espanholas e conduzir com cuidado e respeitar os peões.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "8.- Os dados fornecidos pelo cliente serão utilizados exclusivamente para a correta prestação do serviço contratado, podendo solicitar, nos termos da lei, o seu acesso, retificação, cancelamento ou oposição, comunicando por qualquer meio ao locador. Este contrato é regido pela lei espanhola.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "9.- Caso o locador necessite de assistência em viagem sem ter sido previamente contratado, o custo será de 15€ por hora, e 15€ para deslocação até à zona onde o cliente se encontra.",
              },
              "",
            ],
            [
              {
                colSpan: 2,
                margin: [0, 5, 0, 0],
                fontSize: 10,
                text: "10.- Caso o locador decida devolver as bicicletas em data anterior ao término deste contrato, não terá direito a qualquer reembolso.",
              },
              "",
            ],
            [
              {
                margin: [0, 40, 0, 0],
                fontSize: 10,
                bold: true,
                text: "Assinatura do Proprietário",
              },
              {
                margin: [0, 40, 0, 0],
                fontSize: 10,
                bold: true,
                text: "Assinatura do Locatário - Contratante",
              },
            ],

            [
              {
                width: "auto",
                fit: [180, 100],
                image: imagenFirma,
                alignment: "left",
              },

              {
                text: "",
              },
            ],
          ],
        },
        layout: "noBorders",
      },
    ],
  };

  return docDefinition;
}

